import React, { useCallback, useEffect, useState , useContext } from "react";
import { Modal, ModalBody, ModalContent, ModalOverlay , ModalHeader , ModalFooter  } from "@chakra-ui/modal";
import ReactFlow, {
  MiniMap,
  Controls,
  Background,
  useNodesState,
  useEdgesState,
  addEdge,
  Connection,
  Edge,
  Node,
  Position,
  ReactFlowProvider,
  Handle,
} from "reactflow"; 
import { MultiSelect } from "react-multi-select-component";
import "reactflow/dist/style.css";
import { useDisclosure } from "@chakra-ui/hooks";
import { MdAdd, MdCheck, MdDelete, MdFileCopy, MdHighlightOff } from "react-icons/md";
import Card from "../../../components/card/custom";
import { allCardType , allCurrency , allDays , allCountries } from '../../../utils/smartVariable';
import { TimePicker } from "antd";
import dayjs from "dayjs";
import { BsArrowLeft, BsFiletypeJson } from "react-icons/bs";
import { FiPlusSquare, FiSave, FiUploadCloud, FiXCircle } from "react-icons/fi";
import { createSmartRoutingNew, getSmartRouting , ClientGatewaysForSmartRouting , ClientSuccessGatewaysForSmartRouting } from "../../../api/smart-routing";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";
import { motion } from "framer-motion";
import { ClientContext } from "ClientProvider";
import { Link } from "react-router-dom";
import DivLoader from "components/divloader/DivLoader";
import { useDropzone } from "react-dropzone";
import SampleJson from "../../../assets/json/smartRoutingJson.json";
import SampleJsonRule from "../../../assets/json/smartRoutingJsonRules.txt";
import Radio from "components/radio";
import InputField from "components/fields/InputField";
import TextArea from "components/fields/TextArea";
import { log } from "console";

let id = 0;
const getId = () => `node_${id++}`;
interface Condition {
  key: string;
  operator: string;
  value: string | string[];
  hasError?: boolean;
  hasKeyError?: boolean;
  hasOperatorError?: boolean;
}

const ALLOWED_ACTIONS = ["process_with_gateway","process_with_last_success","process_with_priority","process_transaction_with_status"];
const CONDITION_RULES: Record<
  string,
  {
    operators: string[];
    valueType: "number" | "string" | "array" | "time" | "range" | "card-bin";
    allowedValues?: string[];
  }
> = {
  amount: {
    operators: ["equal", "not_equal", "greater", "less", "between"],
    valueType: "number",
  },
  "card-type": {
    operators: ["equal", "not_equal", "in", "not_in"],
    valueType: "string",
    allowedValues: allCardType.map((c: any) => c.value),
  },
  currency: {
    operators: ["equal", "not_equal", "in", "not_in"],
    valueType: "string",
    allowedValues: allCurrency.map((c: any) => c.value),
  },
  "geo-location": {
    operators: ["equal", "not_equal", "in", "not_in"],
    valueType: "string",
    allowedValues: allCountries.map((c: any) => c.value),
  },
  day: {
    operators: ["equal", "not_equal", "in", "not_in"],
    valueType: "string",
    allowedValues: allDays.map((c: any) => c.value),
  },
  time: {
    operators: ["equal", "not_equal", "greater", "less", "between"],
    valueType: "time",
  },
  "card-bin": {
    operators: ["equal", "not_equal"],
    valueType: "card-bin",
  },
};

const conditionNode = ({ data }: any) => {
  const hasAnyError = data.conditions.some((condition: Condition) =>
    condition.hasError || condition.hasKeyError || condition.hasOperatorError
  );
  const MotionWrapper = hasAnyError ? motion.div : "div";
  return (
    <motion.div
      animate={
        hasAnyError
          ? { x: [0, -3, 3, -3, 3, 0] }
          : { x: 0 }
      }
      transition={hasAnyError ? { duration: 0.3 } : undefined}
    >
    <div className="relative w-[300px] rounded-2xl border border-purple-300 bg-purple-50 shadow-lg p-4 text-sm">
      <button
        className="absolute top-2 right-2 text-purple-500 hover:text-red-600"
        onClick={() => data.onRemove(data.id)}
      >
        <MdHighlightOff size={20} />
      </button>
      <div className="flex items-center gap-2 mb-3">
        <span className="text-purple-600 text-xl">🧠</span>
        <h3 className="text-purple-700 font-bold text-base tracking-wide">Condition - {data.titleIndex} </h3>
      </div>
      <div className="space-y-3">
        {data.conditions.map((condition: any, index: number) => {
          const allKeys = [ "amount","geo-location","card-type","currency","time","day","card-bin",];
          const usedKeys = data.conditions.filter((_ : any, i : any) => i !== index).map((c: any) => c.key);
          const availableKeys = allKeys.filter((k) => !usedKeys.includes(k) || k === condition.key);
          return (
            <div key={index} className="relative bg-white border border-purple-200 rounded-md p-3 shadow-sm space-y-2">
              <div className="grid grid-cols-2 gap-4">
                <div className="w-full">
                  <select
                    className="w-full border rounded px-2 py-1 text-xs"
                    value={condition.key}
                    onChange={(e) => {
                      data.onChange(data.id, "key", e.target.value, index);
                      data.onChange(data.id, "value", "", index);
                      data.onChange(data.id, "operator", "", index);
                      data.onChange(data.id, "hasKeyError", !e.target.value, index);
                      data.onChange(data.id, "hasOperatorError", true, index);

                    }}
                  >
                    <option value="">Select Condition</option>
                    {availableKeys.map((key) => (
                      <option key={key} value={key}>
                        {key.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())}
                      </option>
                    ))}
                  </select>
                  {condition.hasKeyError && <span className="text-red-500 text-xs">Required</span>}
                </div>
                <div className="w-full">
                  <select
                    className="w-full border rounded px-2 py-1 text-xs"
                    value={condition.operator}
                    onChange={(e) => {
                      data.onChange(data.id, "operator", e.target.value, index);
                      data.onChange(data.id, "value", "", index);
                      data.onChange(data.id, "hasOperatorError", !e.target.value, index);
                      data.onChange(data.id, "hasError", true, index);
                    }}
                  >
                    <option value="">Select Operator</option>
                    <option value="equal">Equals</option>
                    <option value="not_equal">Not Equals</option>
                    {condition.key === 'amount' || condition.key === 'time' ? (
                      <>
                        <option value="greater">Greater Than</option>
                        <option value="less">Less Than</option>
                        <option value="between">Range</option>
                      </>
                    ) : condition.key === 'geo-location' || condition.key === 'card-type' || condition.key === 'currency' || condition.key === 'day' ? (
                      <>
                        <option value="in">In</option>
                        <option value="not_in">Not In</option>
                      </> 
                    ) : null}
                  </select>
                  {condition.hasOperatorError && <span className="text-red-500 text-xs">Required</span>}
                </div>
              </div>
              {condition.key === 'amount' ? (
                condition.operator === 'between' ? (
                  <>
                    <div className="flex gap-2">
                      <div className="w-1/2 flex flex-col">
                        <input
                          type="text"
                          className="w-full border rounded px-2 py-1 text-xs"
                          placeholder="Min"
                          value={condition.value?.split(',')[0] || ""}
                          onChange={(e) => {
                            const min = e.target.value;
                            const max = condition.value?.split(',')[1] || "";
                            if (/^\d*\.?\d*$/.test(min)) {
                              data.onChange(data.id, "value", `${min},${max}`, index); 
                            }
                            if(condition.value?.split(',')[0] != "" && condition.value?.split(',')[1]!= "") {
                              data.onChange(data.id, "hasError", !min, index);
                            }
                          }}
                        />
                      </div>
                      <div className="w-1/2 flex flex-col">
                        <input
                          type="text"
                          className="w-full border rounded px-2 py-1 text-xs"
                          placeholder="Max"
                          value={condition.value?.split(',')[1] || ""}
                          onChange={(e) => {
                            const max = e.target.value;
                            const min = condition.value?.split(',')[0] || "";
                            if (/^\d*\.?\d*$/.test(max)) {
                              data.onChange(data.id, "value", `${min},${max}`, index);
                            }
                            if(condition.value?.split(',')[0] != "" && condition.value?.split(',')[1]!= "") {
                              data.onChange(data.id, "hasError", !max, index);
                            }
                          }}
                        />
                      </div>
                    </div>
                    {condition.hasError && <span className="text-red-500 text-xs">Required</span>}
                  </>
                ) : (
                  <>
                    <input
                      type="text"
                      className="w-full border rounded px-2 py-1 text-xs"
                      placeholder="Enter value"
                      value={condition.value}
                      onChange={(e) => {
                        const val = e.target.value;
                        if (/^\d*\.?\d*$/.test(val)) {
                          data.onChange(data.id, "value", val, index);
                          data.onChange(data.id, "hasError", !val, index);
                        }
                      }}
                    />
                    {condition.hasError && <span className="text-red-500 text-xs">Required</span>}
                  </>
                )
              ) : condition.key === 'card-bin' ? (
                <>
                  <input
                    type="text"
                    className="w-full border rounded px-2 py-1 text-xs"
                    placeholder="Enter value"
                    value={condition.value}
                    maxLength={6}
                    onChange={(e) => {
                      const val = e.target.value;
                      const isNumeric = /^\d*$/.test(val);
                      const isCardBin = condition.key === "card-bin";
                      if (isNumeric) {
                        let isValid = true;
                        if (isCardBin) {
                          isValid = val.length === 6;
                        } else {
                          isValid = val.length <= 6;
                        }
                        data.onChange(data.id, "value", val, index);
                        data.onChange(data.id, "hasError", !isValid, index);
                      }
                    }}
                  />
                  {condition.hasError && (
                    <span className="text-red-500 text-xs">
                      {condition.value === ""
                        ? "Required"
                        : condition.value.length !== 6
                        ? "Must be exactly 6 digits"
                        : "Required"}
                    </span>
                  )}

                </>
              ) : condition.key === 'currency' ? (
                condition.operator === 'in' || condition.operator === 'not_in' ? (
                  <>
                    <MultiSelect
                      options={allCurrency}
                      value={allCurrency.filter(opt => condition.value?.includes(opt.value))}
                      onChange={(selected: any) => {
                        const values = selected.map((s: any) => s.value);
                        data.onChange(data.id, "value", values, index);
                        data.onChange(data.id, "hasError", values.length === 0, index);
                      }}
                      labelledBy={"Select"}
                      overrideStrings={{ "noOptions": "Currency not found" }}
                      valueRenderer={(selected, options) => {
                        if (selected.length === 0) return "Select currency";
                        if (selected.length === options.length) return "All currency are selected";
                        return selected.map((option) => option.label).join(", ");
                      }}
                    />
                    {condition.hasError && <span className="text-red-500 text-xs">Required</span>}
                  </>
                ) : (
                  <>
                    <select
                      className="w-full border rounded px-2 py-1 text-xs"
                      value={condition.value}
                      onChange={(e) => {
                        data.onChange(data.id, "value", e.target.value, index);
                        data.onChange(data.id, "hasError", !e.target.value, index);
                      }}
                    >
                      <option value="">Select Currency</option>
                      {allCurrency.map((data: any) => (
                        <option key={data?.value} value={data?.value}>
                          {data?.label}
                        </option>
                      ))}
                    </select>
                    {condition.hasError && <span className="text-red-500 text-xs">Required</span>}
                  </>
                )
              ) : condition.key === 'card-type' ? (
                condition.operator === 'in' || condition.operator === 'not_in' ? (
                  <>
                    <MultiSelect
                      options={allCardType}
                      value={allCardType.filter(opt => condition.value?.includes(opt.value))}
                      onChange={(selected: any) => {
                        const values = selected.map((s: any) => s.value);
                        data.onChange(data.id, "value", values, index);
                        data.onChange(data.id, "hasError", values.length === 0, index);
                      }}
                      labelledBy={"Select"}
                      overrideStrings={{ "noOptions": "Card type not found" }}
                      valueRenderer={(selected, options) => {
                        if (selected.length === 0) return "Select card type";
                        if (selected.length === options.length) return "All card type are selected";
                        return selected.map((option) => option.label).join(", ");
                      }}
                    />
                    {condition.hasError && <span className="text-red-500 text-xs">Required</span>}
                  </>
                ) : (
                  <>
                    <select
                      className="w-full border rounded px-2 py-1 text-xs"
                      value={condition.value}
                      onChange={(e) => {
                        data.onChange(data.id, "value", e.target.value, index);
                        data.onChange(data.id, "hasError", !e.target.value, index);
                      }}
                    >
                      <option value="">Select Cardtype</option>
                      {allCardType.map((data: any) => (
                        <option key={data?.value} value={data?.value}>
                          {data?.label}
                        </option>
                      ))}
                    </select>
                    {condition.hasError && <span className="text-red-500 text-xs">Required</span>}
                  </>
                )
              ) : condition.key === 'day' ? (
                condition.operator === 'in' || condition.operator === 'not_in' ? (
                  <>
                    <MultiSelect
                      options={allDays}
                      value={allDays.filter(opt => condition.value?.includes(opt.value))}
                      onChange={(selected: any) => {
                        const values = selected.map((s: any) => s.value);
                        data.onChange(data.id, "value", values, index);
                        data.onChange(data.id, "hasError", values.length === 0, index);
                      }}
                      labelledBy={"Select"}
                      overrideStrings={{ "noOptions": "Days not found" }}
                      valueRenderer={(selected, options) => {
                        if (selected.length === 0) return "Select days";
                        if (selected.length === options.length) return "All days are selected";
                        return selected.map((option) => option.label).join(", ");
                      }}
                    />
                    {condition.hasError && <span className="text-red-500 text-xs">Required</span>}
                  </>
                ) : (
                  <>
                    <select
                      className="w-full border rounded px-2 py-1 text-xs"
                      value={condition.value}
                      onChange={(e) => {
                        data.onChange(data.id, "value", e.target.value, index);
                        data.onChange(data.id, "hasError", !e.target.value, index);
                      }}
                    >
                      <option value="">Select Day</option>
                      {allDays.map((data: any) => (
                        <option key={data?.value} value={data?.value}>
                          {data?.label}
                        </option>
                      ))}
                    </select>
                    {condition.hasError && <span className="text-red-500 text-xs">Required</span>}
                  </>
                )
              ) : condition.key === 'geo-location' ? (
                condition.operator === 'in' || condition.operator === 'not_in' ? (
                  <>
                    <MultiSelect
                      options={allCountries}
                      value={allCountries.filter(opt => condition.value?.includes(opt.value))}
                      onChange={(selected: any) => {
                        const values = selected.map((s: any) => s.value);
                        data.onChange(data.id, "value", values, index);
                        data.onChange(data.id, "hasError", values.length === 0, index);
                      }}
                      labelledBy={"Select"}
                      overrideStrings={{ "noOptions": "Country not found" }}
                      valueRenderer={(selected, options) => {
                        if (selected.length === 0) return "Select country";
                        if (selected.length === options.length) return "All countries are selected";
                        return selected.map((option) => option.label).join(", ");
                      }}
                    />
                    {condition.hasError && <span className="text-red-500 text-xs">Required</span>}
                  </>
                ) : (
                  <>
                    <select
                      className="w-full border rounded px-2 py-1 text-xs"
                      value={condition.value}
                      onChange={(e) => {
                        data.onChange(data.id, "value", e.target.value, index);
                        data.onChange(data.id, "hasError", !e.target.value, index);
                      }}
                    >
                      <option value="">Select Country</option>
                      {allCountries.map((data: any) => (
                        <option key={data?.value} value={data?.value}>
                          {data?.label}
                        </option>
                      ))}
                    </select>
                    {condition.hasError && <span className="text-red-500 text-xs">Required</span>}
                  </>
                )
              ) : condition.key === 'time' ? (
                condition.operator === 'between' ? (
                  <>
                    <div className="flex gap-2">
                      <div className="w-1/2 flex flex-col">
                        <TimePicker
                          format="HH:mm"
                          value={
                            condition.value?.split(',')[0]
                              ? dayjs(condition.value.split(',')[0], "HH:mm")
                              : null
                          }
                          onChange={(val) => {
                            const end = condition.value?.split(',')[1] || "";
                            const newStart = val ? dayjs(val).format("HH:mm") : "";
                            const newValue = `${newStart},${end}`;

                            data.onChange(data.id, "value", newValue, index);

                            const [s, e] = newValue.split(",");
                            data.onChange(data.id, "hasError", !(s && e), index);
                          }}
                          // onChange={(val) => {
                          //   const end = condition.value?.split(',')[1] || "";
                          //   data.onChange(data.id, "value", `${dayjs(val).format("HH:mm")},${end}`, index);
                          //   if(condition.value?.split(',')[0] != "" && condition.value?.split(',')[1] != "") {
                          //     data.onChange(data.id, "hasError", !val, index);
                          //   }
                          // }}
                          className="w-full"
                        />
                      </div>
                      <div className="w-1/2 flex flex-col">
                        <TimePicker
                          format="HH:mm"
                          disabled={!condition.value?.split(',')[0]}
                          disabledTime={() => {
                            const start = condition.value?.split(',')[0];
                            if (!start) return {};
                            const startTime = dayjs(start, "HH:mm");
                            return {
                              disabledHours: () =>
                                Array.from({ length: startTime.hour() }, (_, i) => i),

                              disabledMinutes: (selectedHour) =>
                                selectedHour === startTime.hour()
                                  ? Array.from(
                                      { length: startTime.minute() + 1 },
                                      (_, i) => i
                                    )
                                  : [],
                            };
                          }}
                          value={
                            condition.value?.split(',')[1]
                              ? dayjs(condition.value.split(',')[1], "HH:mm")
                              : null
                          }
                          onChange={(val) => {
                            const start = condition.value?.split(',')[0] || "";
                            const newEnd = val ? dayjs(val).format("HH:mm") : "";
                            const newValue = `${start},${newEnd}`;

                            data.onChange(data.id, "value", newValue, index);

                            const [s, e] = newValue.split(",");
                            data.onChange(data.id, "hasError", !(s && e), index);
                          }}
                          // onChange={(val) => {
                          //   const start = condition.value?.split(',')[0] || "";
                          //   data.onChange(data.id, "value", `${start},${dayjs(val).format("HH:mm")}`, index);
                          //   if(condition.value?.split(',')[0] != "" && condition.value?.split(',')[1] != "") {
                          //     data.onChange(data.id, "hasError", !val, index);
                          //   }
                          // }}
                          className="w-full"
                        />
                      </div>
                    </div>
                    {condition.hasError && <span className="text-red-500 text-xs">Required</span>}
                  </>
                ) : (
                  <>
                    <TimePicker
                      onChange={(val) => {
                        data.onChange(data.id, "value", dayjs(val).format("HH:mm"), index);
                        data.onChange(data.id, "hasError", !val, index);
                      }}
                      value={condition.value ? dayjs(condition.value, "HH:mm") : null}
                      format="HH:mm"
                      className="w-full"
                    />
                    {condition.hasError && <span className="text-red-500 text-xs">Required</span>}
                  </>
                )
              ) : null}
              {index > 0 && (
                <button
                  className="absolute top-[-15px] right-[-5px] text-purple-500 hover:text-red-600"
                  onClick={() => data.removeCondition(data.id, index)}
                >
                  <MdHighlightOff size={20} />
                </button>
              )}
            </div>
          )
        })}
        {data.conditions.length < 7 && (
        <button
          className="text-xs text-purple-600 hover:underline mt-2"
          onClick={() => data.addCondition(data.id)}
        >
          ➕ Add Condition
        </button>
        )}
      </div>
      <Handle type="source" position={Position.Right} className="custom-handle-condition"/>
    </div>
    </motion.div>
  )
};

const actionNode = ({ data }: any) => {
  const hasAnyError = data.hasActionError || data.hasGatewayError;
  const MotionWrapper = hasAnyError ? motion.div : "div";

  const moveUp = (list: any[], index: number) => {
    if (index === 0) return list;
    const newList = [...list];
    [newList[index - 1], newList[index]] = [
      newList[index],
      newList[index - 1],
    ];
    return newList;
  };

  const moveDown = (list: any[], index: number) => {
    if (index === list.length - 1) return list;
    const newList = [...list];
    [newList[index], newList[index + 1]] = [
      newList[index + 1],
      newList[index],
    ];
    return newList;
  };

  return (
    <motion.div
      animate={
        hasAnyError
          ? { x: [0, -3, 3, -3, 3, 0] }
          : { x: 0 }
      }
      transition={hasAnyError ? { duration: 0.3 } : undefined}
    >
    <div className="relative w-[300px] rounded-xl shadow-md border bg-green-50 p-4 text-sm space-y-3">
      <button
        className="absolute top-1 right-1 text-red-500 hover:text-red-700"
        onClick={() => data.onRemove(data.id)}
      >
        <MdHighlightOff size={18} />
      </button>
      <h3 className="font-semibold text-green-700">⚙️ Action</h3>
      <select
      className="w-full border rounded px-2 py-1 text-sm"
      value={data.action}
      onChange={async (e) =>  { 
        const value = e.target.value;
        data.onChange(data.id, "action", value);
        data.onChange(data.id, "hasGatewayError", false);
        data.onChange(data.id, "hasStatusError", false);
        data.onChange(data.id, "hasStatusDescriptionError", false);
        data.onChange(data.id, "cred_type", 'existing')
        // data.onChange(data.id, "credentialErrors", {});
        // data.onChange(data.id, "credentials", {});
        if (value === "process_with_gateway") {
          data.onChange(data.id, "gateway", "");
          const normalSuccessGateways = await data.fetchNormalGateways();
          data.onChange(
            data.id,
            "gateways",
            normalSuccessGateways
          );
        }
        if (value === "process_with_last_success") {
          data.onChange(data.id, "gateway", "");

          const [normalGateways, successGateways] = await Promise.all([
            data.fetchNormalGateways(),
            data.fetchSuccessGateways()
          ]);

          const successIds = new Set(
            successGateways.map((g: any) => g.id)
          );

          const reorderedGateways = [...normalGateways].sort(
            (a: any, b: any) => {
              const aIsSuccess = successIds.has(a.id);
              const bIsSuccess = successIds.has(b.id);

              if (aIsSuccess && !bIsSuccess) return -1;
              if (!aIsSuccess && bIsSuccess) return 1;
              return 0;
            }
          );

          // const updatedSuccessGateways = await data.fetchSuccessGateways();
          data.onChange(
            data.id,
            "successGateways",
            reorderedGateways
          );
          const defaultPriority = (reorderedGateways ?? []).map(
              (g: any) => g.id
            );
          data.onChange(data.id, "gateway", defaultPriority);
        }
        if (value === "process_with_priority") {
          const normalSuccessGateways = await data.fetchNormalGateways();
          if (normalSuccessGateways.length > 0) {
            data.onChange(
              data.id,
              "gateways",
              normalSuccessGateways
            );
            const defaultPriority = (normalSuccessGateways ?? []).map(
              (g: any) => g.id
            );
            data.onChange(data.id, "gateway", defaultPriority);
          }
        }
        if (value === "process_transaction_with_status") {
          data.onChange(data.id, "gateway", "");
          const normalSuccessGateways = await data.fetchNormalGateways();
          data.onChange(
            data.id,
            "gateways",
            normalSuccessGateways
          );
        }
      }}
      >
      <option value="process_with_gateway">Process With Gateway</option>
      <option value="process_with_last_success">Process With Last Success gateway</option>
      <option value="process_with_priority">Process With Priority</option>
      <option value="process_transaction_with_status">Process Transaction With Status</option>
      </select>
      {data.hasActionError && (<span className="text-red-500 text-xs">Required</span>)}
      {data.action === 'process_with_gateway' ? ( 
        <>
          <div className="w-100">
            <select
              className="w-full border rounded px-2 py-1 text-sm"
              value={data.gateway}
              onChange={(e) =>  {
                data.onChange(data.id, "gateway", e.target.value)
                data.onChange(data.id, "hasGatewayError", false)
                data.onChange(data.id, "cred_type", 'existing')
                data.onChange(data.id, "credentialErrors", {});
                // data.onChange(data.id, "credentials", {});
              }}
            >
              <option value="">Select Gateway</option>
              {(data.gateways ?? []).map((gate: any) => (
                <option key={gate?.id} value={gate?.id}>
                  {gate?.name}
                </option>
              ))}
            </select>
            {data.hasGatewayError && (<span className="text-red-500 text-xs">Required</span>)}
          </div>
          {data.gateway  && (
            <div className="w-100">
              <p className="text-xs">Choose credentials type</p>
              <div className="mt-2 flex gap-8 mb-2">
                <div className="flex gap-2">
                  <Radio
                    id="existing"
                    value={"existing"}
                    checked={data.cred_type === "existing"}
                    onChange={(e :any) => {
                      data.onChange(data.id, "cred_type", e.target.value)
                    }}
                  />
                  <label htmlFor="existing">
                    Existing
                  </label>
                </div>
                {(
                  data.gateway === '861afd0f-523a-4ce2-8b23-443c604feb2c' || 
                  data.gateway === 'eb4c5a8e-7ba1-4740-9535-0d8b72ff0e1d' || 
                  data.gateway === '7fbef566-cfd0-4d60-856e-3be5ac521eb8' || 
                  data.gateway === '4d10accf-1248-4ebf-a243-33e21ff37c90'   ||
                  data.gateway === '2bfead52-3440-4159-bbff-7a795dcddbe1'   ||
                  data.gateway === '596c3855-0620-4135-bb1f-782f44a03785' ||
                  data.gateway === '9df8db6d-dfa4-4a24-a0f7-e9d66c9be423'   ||
                  data.gateway === 'e08fcfe1-164e-46aa-a758-57b0638f2875' ||
                  data.gateway === '3b9c196c-fbe9-4356-be6a-eb3ebca5df24' ||
                  data.gateway === '9083143f-f488-4eaa-9f10-4580bb107ca6' || 
                  data.gateway === 'bda2ba8d-bd2e-441c-acd6-44ab03794b0c' || 
                  data.gateway === '78151478-a258-4e9e-b91c-4f696c176ac1' ||
                  data.gateway === 'ade468a9-a822-4c1d-a4f9-5bfb40ed842a' ||
                  data.gateway === 'ed068bb2-441e-4325-814c-a8c737f9c16d' || 
                  data.gateway === 'c1f00345-f952-4d20-9f97-768f41cd6e2e' ||
                  data.gateway === 'e95cb998-9a85-4a3d-b90d-5685fa662488' ||
                  data.gateway === '2615c804-0b38-455b-a82c-fc5b5061c364' ||
                  data.gateway === '03315e64-86e9-4871-8d4f-d28e40b857c0' ||
                  data.gateway === 'a059c401-1e01-4d82-9864-6a7b805db6d8' ||
                  data.gateway === '96bcc19b-db68-4b32-84d3-08549fb04b99' ||
                  data.gateway === '35e149f1-1a2c-4ec2-a6cc-8fc0d6bcdf87' ||
                  data.gateway === 'd8fc67f8-2a9e-4aae-a77c-daf3c89e8777' ||
                  data.gateway === 'e3e30eee-36de-4a89-abcb-d05ced13e610' ||
                  data.gateway === 'd9112e48-cd7b-4fc8-aa07-b38062a0a57f' ||
                  data.gateway === 'eaf4e383-3caf-4509-865c-4559ff1737a2' ||
                  data.gateway === 'f3994099-aa66-4bcd-9105-0c529c06236b' ||
                  data.gateway === '162f8652-23e5-4890-b8e7-e34c43d6ab6d'
                ) && (
                  <div className="flex gap-2">
                    <Radio
                      id="custom"
                      value={"custom"}
                      checked={data.cred_type === "custom"}
                      onChange={(e :any) => {
                        data.onChange(data.id, "cred_type", e.target.value)
                      }}
                    />
                    <label htmlFor="custom">
                      Custom
                    </label>
                  </div>
                )}
              </div> 
              {data.cred_type==='custom' && (
                <div className="mt-2 mb-2">
                  {(data.gateway === '861afd0f-523a-4ce2-8b23-443c604feb2c' || data.gateway === 'eb4c5a8e-7ba1-4740-9535-0d8b72ff0e1d') ? (
                    <>
                      <div  key={data.id}  className="relative mt-5 max-h-[calc(100vh-300px)] overflow-auto overflow-x-hidden rounded-xl border border-gray-200 bg-white p-5 shadow-3xl shadow-shadow-500 scrollbar-thin scrollbar-track-gray-100 scrollbar-thumb-gray-300 dark:!border-white/10 dark:bg-navy-800 dark:shadow-none">  
                        <InputField
                          variant="auth"
                          extra="mb-1"
                          label="Public Api Key*"
                          placeholder="Public Api Key"
                          id="public_api_key_test"
                          type="text"
                          value={data.credentials?.public_api_key ?? ""}
                          onChange={(e) => {
                            const value = e.target.value;
                            data.onChange(data.id, "credentials.public_api_key", value);
                            if (value) {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                public_api_key: false,
                              });
                            } else {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                public_api_key: true,
                              });
                            }
                          }}
                        />
                        {data.credentialErrors?.public_api_key && (
                          <span className="text-red-500 text-xs">Required</span>
                        )}
                        <InputField
                          variant="auth"
                          extra="mb-1"
                          label="Private Key*"
                          placeholder="Private Key"
                          id="private_key_test"
                          type="text"
                          value={data.credentials?.private_key ?? ""}
                          onChange={(e) => {
                            const value = e.target.value;
                            data.onChange(data.id, "credentials.private_key", value);
                            if (value) {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                private_key: false,
                              });
                            } else {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                private_key: true,
                              });
                            }
                          }}
                        />
                        {data.credentialErrors?.private_key && (
                          <span className="text-red-500 text-xs">Required</span>
                        )}
                        <div className="flex gap-8">
                          <div className="flex gap-2">
                            <label className={`ml-1.5 mr-3 text-sm font-bold text-gray-900 text-navy-700 dark:text-white`}>
                              Provider *
                            </label>
                          </div>
                        </div>
                        <div className="mb-1 flex items-center justify-center">
                          <select
                            id="provider_test"
                            name="provider_test"
                            value={data.credentials?.provider ?? ""}
                            onChange={(e) => {
                              const value = e.target.value;
                              data.onChange(data.id, "credentials.provider", value);
                              if (value) {
                                data.onChange(data.id, "credentialErrors", {
                                  ...data.credentialErrors,
                                  provider: false,
                                });
                              } else {
                                data.onChange(data.id, "credentialErrors", {
                                  ...data.credentialErrors,
                                  provider: true,
                                });
                              }
                            }}
                            className={`mt-1 flex h-10 w-full items-center justify-center rounded-xl border bg-white/0 p-2 text-sm text-gray-700 outline-none dark:!bg-white/5 dark:placeholder:!text-[rgba(255,255,255,0.15)] border-gray-300 dark:border-white/10`}
                          >
                            <option value="">Select Provider</option>
                            <option value="banxa">Banxa</option>
                            <option value="moonpay">Moonpay</option>
                            <option value="transak">Transak</option>
                            <option value="wert">Wert</option>
                            <option value="skrill_crypto">Skrill Crypto</option>
                          </select>
                        </div>  
                        {data.credentialErrors?.provider && (
                          <span className="text-red-500 text-xs">Required</span>
                        )}
                        <InputField
                          variant="auth"
                          extra="mb-1"
                          label="Wallet Address*"
                          placeholder="Wallet Address"
                          id="wallet_address_test"
                          type="text"
                          value={data.credentials?.wallet_address ?? ""}
                          onChange={(e) => {
                            const value = e.target.value;
                            data.onChange(data.id, "credentials.wallet_address", value);
                            if (value) {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                wallet_address: false,
                              });
                            } else {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                wallet_address: true,
                              });
                            }
                          }}
                        />
                        {data.credentialErrors?.wallet_address && (
                          <span className="text-red-500 text-xs">Required</span>
                        )}
                        <InputField
                          variant="auth"
                          extra="mb-1"
                          label="To Currency*"
                          placeholder="To Currency"
                          id="to_currency_test"
                          type="text"
                          value={data.credentials?.to_currency ?? ""}
                          onChange={(e) => {
                            const value = e.target.value;
                            data.onChange(data.id, "credentials.to_currency", value);
                            if (value) {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                to_currency: false,
                              });
                            } else {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                to_currency: true,
                              });
                            }
                          }}
                        />
                        {data.credentialErrors?.to_currency && (
                          <span className="text-red-500 text-xs">Required</span>
                        )}
                      </div>
                    </>
                  ) : data.gateway === '7fbef566-cfd0-4d60-856e-3be5ac521eb8' || data.gateway === '4d10accf-1248-4ebf-a243-33e21ff37c90' ? (
                    <>
                      <div  key={data.id}  className="relative mt-5 max-h-[calc(100vh-300px)] overflow-auto overflow-x-hidden rounded-xl border border-gray-200 bg-white p-5 shadow-3xl shadow-shadow-500 scrollbar-thin scrollbar-track-gray-100 scrollbar-thumb-gray-300 dark:!border-white/10 dark:bg-navy-800 dark:shadow-none">  
                        <InputField
                          variant="auth"
                          extra="mb-1"
                          label="Public Api Key*"
                          placeholder="Public Api Key"
                          id="public_api_key_test"
                          type="text"
                          value={data.credentials?.public_api_key ?? ""}
                          onChange={(e) => {
                            const value = e.target.value;
                            data.onChange(data.id, "credentials.public_api_key", value);
                            if (value) {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                public_api_key: false,
                              });
                            } else {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                public_api_key: true,
                              });
                            }
                          }}
                        />
                        {data.credentialErrors?.public_api_key && (
                          <span className="text-red-500 text-xs">Required</span>
                        )}
                        <TextArea
                          variant="auth"
                          extra="mb-1"
                          label="Private Key*"
                          placeholder="Private Key"
                          id="private_key_test"
                          value={data.credentials?.private_key ?? ""}
                          onChange={(e) => {
                            const value = e.target.value;
                            data.onChange(data.id, "credentials.private_key", value);
                            if (value) {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                private_key: false,
                              });
                            } else {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                private_key: true,
                              });
                            }
                          }}
                        />
                        {data.credentialErrors?.private_key && (
                          <span className="text-red-500 text-xs">Required</span>
                        )}
                      </div>
                    </>
                  ) : data.gateway === '2bfead52-3440-4159-bbff-7a795dcddbe1' || data.gateway === '596c3855-0620-4135-bb1f-782f44a03785' ? (
                    <>
                      <div  key={data.id}  className="relative mt-5 max-h-[calc(100vh-300px)] overflow-auto overflow-x-hidden rounded-xl border border-gray-200 bg-white p-5 shadow-3xl shadow-shadow-500 scrollbar-thin scrollbar-track-gray-100 scrollbar-thumb-gray-300 dark:!border-white/10 dark:bg-navy-800 dark:shadow-none">  
                        <InputField
                          variant="auth"
                          extra="mb-1"
                          label="Api Key*"
                          placeholder="Api Key"
                          id="api_key_test"
                          type="text"
                          value={data.credentials?.api_key ?? ""}
                          onChange={(e) => {
                            const value = e.target.value;
                            data.onChange(data.id, "credentials.api_key", value);
                            if (value) {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                api_key: false,
                              });
                            } else {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                api_key: true,
                              });
                            }
                          }}
                        />
                        {data.credentialErrors?.api_key && (
                          <span className="text-red-500 text-xs">Required</span>
                        )}
                        <InputField
                          variant="auth"
                          extra="mb-1"
                          label="Api Secret*"
                          placeholder="Api Secret"
                          id="api_secret_test"
                          type="text"
                          value={data.credentials?.api_secret ?? ""}
                          onChange={(e) => {
                            const value = e.target.value;
                            data.onChange(data.id, "credentials.api_secret", value);
                            if (value) {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                api_secret: false,
                              });
                            } else {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                api_secret: true,
                              });
                            }
                          }}
                        />
                        {data.credentialErrors?.api_secret && (
                          <span className="text-red-500 text-xs">Required</span>
                        )}
                        <div className=" flex gap-8">
                          <div className="flex gap-2">
                            <label
                              className={`ml-1.5 mr-3 text-sm font-bold text-gray-900 text-navy-700 dark:text-white`}
                            >
                              APM Payment Method *
                            </label>
                          </div>
                        </div>
                        <div className="mb-1 flex items-center justify-center">
                          <select
                            id="payment_method_test"
                            name="payment_method_test"
                            value={data.credentials?.payment_method ?? ""}
                            // onChange={handleValueChange}
                            onChange={(e) => {
                            const value = e.target.value;
                            data.onChange(data.id, "credentials.payment_method", value);
                            if (value) {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                payment_method: false,
                              });
                            } else {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                payment_method: true,
                              });
                            }
                          }}
                            className={`mt-1 flex h-10 w-full items-center justify-center rounded-xl border bg-white/0 p-2 text-sm text-gray-700 outline-none
                              dark:!bg-white/5 dark:placeholder:!text-[rgba(255,255,255,0.15)]`}
                          >
                            <option value="">Select payment method</option>
                            <option value="GCash-AP">GCash-AP</option>
                            <option value="PayMaya-AP">PayMaya-AP</option>
                            <option value="Gotyme-AP">Gotyme-AP</option>
                            <option value="Grabpay-AP">Grabpay-AP</option>
                            <option value="DUITNOW-AP">DUITNOW-AP</option>
                            <option value="TouchNGo-AP">TouchNGo-AP</option>
                            <option value="ShopeePay-AP">ShopeePay-AP</option>
                            <option value="GrabPay-MYR-AP">GrabPay-MYR-AP</option>
                            <option value="BoostPay-AP">BoostPay-AP</option>
                            <option value="FPX-MYR-AP">FPX-MYR-AP</option>
                            <option value="OnlineBanking-MYR-AP">OnlineBanking-MYR-AP</option>
                            <option value="DanaWallet-AP">DanaWallet-AP</option>
                            <option value="OvoWallet-AP">OvoWallet-AP</option>
                            <option value="QRIS-IDR-AP">QRIS-IDR-AP</option>
                            <option value="VirutalAccount-IDR-AP">VirutalAccount-IDR-AP</option>
                            <option value="OnlineBanking-IDR-AP">OnlineBanking-IDR-AP</option>
                            <option value="Momo-AP">Momo-AP</option>
                            <option value="Vieel-AP">Vieel-AP</option>
                            <option value="Zalo-AP">Zalo-AP</option>
                            <option value="BankTransfer-VND-AP">BankTransfer-VND-AP</option>
                            <option value="VierQR-AP">VierQR-AP</option>
                            <option value="MomoVietQR-AP">MomoVietQR-AP</option>
                            <option value="TrueMoney-AP">TrueMoney-AP</option>
                            <option value="BankTransfer-THB-AP">BankTransfer-THB-AP</option>
                            <option value="Promptpay-AP">Promptpay-AP</option>
                            <option value="UPI-AP">UPI-AP</option>
                            <option value="OnlineBanking-SGD-AP">OnlineBanking-SGD-AP</option>
                            <option value="BankTransfer-HKD-AP">BankTransfer-HKD-AP</option>
                            <option value="TAPNGO-AP">TAPNGO-AP</option>
                          </select>
                        </div> 
                        {data.credentialErrors?.payment_method && (
                          <span className="text-red-500 text-xs">Required</span>
                        )}
                        <div className=" flex gap-8">
                          <div className="flex gap-2">
                            <label
                              className={`ml-1.5 mr-3 text-sm font-bold text-gray-900 text-navy-700 dark:text-white`}
                            >
                              Payout Payment Method *
                            </label>
                          </div>
                        </div>
                        <div className="mb-1 flex items-center justify-center">
                          <select
                            id="payout_payment_method_test"
                            name="payout_payment_method_test"
                            value={data.credentials?.payout_payment_method ?? ""}
                            // onChange={handleValueChange}
                            onChange={(e) => {
                            const value = e.target.value;
                            data.onChange(data.id, "credentials.payout_payment_method", value);
                            if (value) {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                payout_payment_method: false,
                              });
                            } else {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                payout_payment_method: true,
                              });
                            }
                          }}
                            className={`mt-1 flex h-10 w-full items-center justify-center rounded-xl border bg-white/0 p-2 text-sm text-gray-700 outline-none
                              dark:!bg-white/5 dark:placeholder:!text-[rgba(255,255,255,0.15)]`}
                          >
                            <option value="">Select payment method</option>
                            <option value="payout-PHP-AP">payout-PHP-AP</option>
                            <option value="BankTransfer-payout-IDR-AP">BankTransfer-payout-IDR-AP</option>
                            <option value="BankTransfer-payout-VND-AP">BankTransfer-payout-VND-AP</option>
                            <option value="BankTransfer-payout-THB-AP">BankTransfer-payout-THB-AP</option>
                            <option value="BankTransfer-payout-INR-AP">BankTransfer-payout-INR-AP</option>
                            <option value="BankTransfer-payout-SGD-AP">BankTransfer-payout-SGD-AP</option>
                            <option value="BankTransfer-payout-HKD-AP">BankTransfer-payout-HKD-AP</option>
                          </select>
                        </div> 
                        {data.credentialErrors?.payout_payment_method && (
                          <span className="text-red-500 text-xs">Required</span>
                        )}
                      </div>
                    </>
                  ) : data.gateway === '9df8db6d-dfa4-4a24-a0f7-e9d66c9be423' || data.gateway === 'e08fcfe1-164e-46aa-a758-57b0638f2875' ? (
                    <>
                      <div  key={data.id}  className="relative mt-5 max-h-[calc(100vh-300px)] overflow-auto overflow-x-hidden rounded-xl border border-gray-200 bg-white p-5 shadow-3xl shadow-shadow-500 scrollbar-thin scrollbar-track-gray-100 scrollbar-thumb-gray-300 dark:!border-white/10 dark:bg-navy-800 dark:shadow-none">  
                        <InputField
                          variant="auth"
                          extra="mb-1"
                          label="Api Key*"
                          placeholder="Api Key"
                          id="api_key_test"
                          type="text"
                          value={data.credentials?.api_key ?? ""}
                          onChange={(e) => {
                            const value = e.target.value;
                            data.onChange(data.id, "credentials.api_key", value);
                            if (value) {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                api_key: false,
                              });
                            } else {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                api_key: true,
                              });
                            }
                          }}
                        />
                        {data.credentialErrors?.api_key && (
                          <span className="text-red-500 text-xs">Required</span>
                        )}
                        <InputField
                          variant="auth"
                          extra="mb-1"
                          label="Api Secret*"
                          placeholder="Api Secret"
                          id="api_secret_test"
                          type="text"
                          value={data.credentials?.api_secret ?? ""}
                          onChange={(e) => {
                            const value = e.target.value;
                            data.onChange(data.id, "credentials.api_secret", value);
                            if (value) {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                api_secret: false,
                              });
                            } else {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                api_secret: true,
                              });
                            }
                          }}
                        />
                        {data.credentialErrors?.api_secret && (
                          <span className="text-red-500 text-xs">Required</span>
                        )}
                      </div>
                    </>
                  ) : data.gateway === '3b9c196c-fbe9-4356-be6a-eb3ebca5df24' || data.gateway === '9083143f-f488-4eaa-9f10-4580bb107ca6' ? (
                    <>
                      <div  key={data.id}  className="relative mt-5 max-h-[calc(100vh-300px)] overflow-auto overflow-x-hidden rounded-xl border border-gray-200 bg-white p-5 shadow-3xl shadow-shadow-500 scrollbar-thin scrollbar-track-gray-100 scrollbar-thumb-gray-300 dark:!border-white/10 dark:bg-navy-800 dark:shadow-none">  
                        <InputField
                          variant="auth"
                          extra="mb-1"
                          label="Api ID*"
                          placeholder="Api ID"
                          id="api_id_test"
                          type="text"
                          value={data.credentials?.api_id ?? ""}
                          onChange={(e) => {
                            const value = e.target.value;
                            data.onChange(data.id, "credentials.api_id", value);
                            if (value) {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                api_id: false,
                              });
                            } else {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                api_id: true,
                              });
                            }
                          }}
                        />
                        {data.credentialErrors?.api_id && (
                          <span className="text-red-500 text-xs">Required</span>
                        )}
                        <InputField
                          variant="auth"
                          extra="mb-1"
                          label="Api Key*"
                          placeholder="Api Key"
                          id="api_key_test"
                          type="text"
                          value={data.credentials?.api_key ?? ""}
                          onChange={(e) => {
                            const value = e.target.value;
                            data.onChange(data.id, "credentials.api_key", value);
                            if (value) {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                api_key: false,
                              });
                            } else {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                api_key: true,
                              });
                            }
                          }}
                        />
                        {data.credentialErrors?.api_key && (
                          <span className="text-red-500 text-xs">Required</span>
                        )}
                      </div>
                    </>
                  ) : data.gateway === 'bda2ba8d-bd2e-441c-acd6-44ab03794b0c' || data.gateway === '78151478-a258-4e9e-b91c-4f696c176ac1' ? (
                    <>
                      <div  key={data.id}  className="relative mt-5 max-h-[calc(100vh-300px)] overflow-auto overflow-x-hidden rounded-xl border border-gray-200 bg-white p-5 shadow-3xl shadow-shadow-500 scrollbar-thin scrollbar-track-gray-100 scrollbar-thumb-gray-300 dark:!border-white/10 dark:bg-navy-800 dark:shadow-none">  
                        <InputField
                          variant="auth"
                          extra="mb-1"
                          label="Endpoint ID*"
                          placeholder="Endpoint ID"
                          id="endpoint_id_test"
                          type="text"
                          value={data.credentials?.endpoint_id ?? ""}
                          onChange={(e) => {
                            const value = e.target.value;
                            data.onChange(data.id, "credentials.endpoint_id", value);
                            if (value) {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                endpoint_id: false,
                              });
                            } else {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                endpoint_id: true,
                              });
                            }
                          }}
                        />
                        {data.credentialErrors?.endpoint_id && (
                          <span className="text-red-500 text-xs">Required</span>
                        )}
                        <InputField
                          variant="auth"
                          extra="mb-1"
                          label="Merchant Key*"
                          placeholder="Merchant Key"
                          id="merchant_key_test"
                          type="text"
                          value={data.credentials?.merchant_key ?? ""}
                          onChange={(e) => {
                            const value = e.target.value;
                            data.onChange(data.id, "credentials.merchant_key", value);
                            if (value) {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                merchant_key: false,
                              });
                            } else {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                merchant_key: true,
                              });
                            }
                          }}
                        />
                        {data.credentialErrors?.merchant_key && (
                          <span className="text-red-500 text-xs">Required</span>
                        )}
                      </div>
                    </>
                  ) : data.gateway === 'ade468a9-a822-4c1d-a4f9-5bfb40ed842a' || data.gateway === 'ed068bb2-441e-4325-814c-a8c737f9c16d' ? (
                    <>
                      <div  key={data.id}  className="relative mt-5 max-h-[calc(100vh-300px)] overflow-auto overflow-x-hidden rounded-xl border border-gray-200 bg-white p-5 shadow-3xl shadow-shadow-500 scrollbar-thin scrollbar-track-gray-100 scrollbar-thumb-gray-300 dark:!border-white/10 dark:bg-navy-800 dark:shadow-none">  
                        <InputField
                          variant="auth"
                          extra="mb-1"
                          label="Client Key*"
                          placeholder="Client Key"
                          id="client_key_test"
                          type="text"
                          value={data.credentials?.client_key ?? ""}
                          onChange={(e) => {
                            const value = e.target.value;
                            data.onChange(data.id, "credentials.client_key", value);
                            if (value) {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                client_key: false,
                              });
                            } else {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                client_key: true,
                              });
                            }
                          }}
                        />
                        {data.credentialErrors?.client_key && (
                          <span className="text-red-500 text-xs">Required</span>
                        )}
                        <InputField
                          variant="auth"
                          extra="mb-1"
                          label="Password*"
                          placeholder="Password"
                          id="password_test"
                          type="text"
                          value={data.credentials?.password ?? ""}
                          onChange={(e) => {
                            const value = e.target.value;
                            data.onChange(data.id, "credentials.password", value);
                            if (value) {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                password: false,
                              });
                            } else {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                password: true,
                              });
                            }
                          }}
                        />
                        {data.credentialErrors?.password && (
                          <span className="text-red-500 text-xs">Required</span>
                        )}
                        <InputField
                          variant="auth"
                          extra="mb-1"
                          label="Brand*"
                          placeholder="Brand"
                          id="brand_test"
                          type="text"
                          value={data.credentials?.brand ?? ""}
                          onChange={(e) => {
                            const value = e.target.value;
                            data.onChange(data.id, "credentials.brand", value);
                            if (value) {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                brand: false,
                              });
                            } else {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                brand: true,
                              });
                            }
                          }}
                        />
                        {data.credentialErrors?.brand && (
                          <span className="text-red-500 text-xs">Required</span>
                        )}
                        <InputField
                          variant="auth"
                          extra="mb-1"
                          label="Payout Client Key*"
                          placeholder="Payout Client Key"
                          id="payout_client_key_test"
                          type="text"
                          value={data.credentials?.payout_client_key ?? ""}
                          onChange={(e) => {
                            const value = e.target.value;
                            data.onChange(data.id, "credentials.payout_client_key", value);
                            if (value) {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                payout_client_key: false,
                              });
                            } else {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                payout_client_key: true,
                              });
                            }
                          }}
                        />
                        {data.credentialErrors?.payout_client_key && (
                          <span className="text-red-500 text-xs">Required</span>
                        )}
                        <InputField
                          variant="auth"
                          extra="mb-1"
                          label="Payout Password*"
                          placeholder="Payout Password"
                          id="payout_password_test"
                          type="text"
                          value={data.credentials?.payout_password ?? ""}
                          onChange={(e) => {
                            const value = e.target.value;
                            data.onChange(data.id, "credentials.payout_password", value);
                            if (value) {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                payout_password: false,
                              });
                            } else {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                payout_password: true,
                              });
                            }
                          }}
                        />
                        {data.credentialErrors?.payout_password && (
                          <span className="text-red-500 text-xs">Required</span>
                        )}
                        <InputField
                          variant="auth"
                          extra="mb-1"
                          label="Payout Brand*"
                          placeholder="Payout Brand"
                          id="payout_brand_test"
                          type="text"
                          value={data.credentials?.payout_brand ?? ""}
                          onChange={(e) => {
                            const value = e.target.value;
                            data.onChange(data.id, "credentials.payout_brand", value);
                            if (value) {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                payout_brand: false,
                              });
                            } else {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                payout_brand: true,
                              });
                            }
                          }}
                        />
                        {data.credentialErrors?.payout_brand && (
                          <span className="text-red-500 text-xs">Required</span>
                        )}
                      </div>
                    </>
                  ) : data.gateway === 'c1f00345-f952-4d20-9f97-768f41cd6e2e' ? (
                    <>
                      <div  key={data.id}  className="relative mt-5 max-h-[calc(100vh-300px)] overflow-auto overflow-x-hidden rounded-xl border border-gray-200 bg-white p-5 shadow-3xl shadow-shadow-500 scrollbar-thin scrollbar-track-gray-100 scrollbar-thumb-gray-300 dark:!border-white/10 dark:bg-navy-800 dark:shadow-none">  
                        <InputField
                          variant="auth"
                          extra="mb-1"
                          label="Secret Key*"
                          placeholder="Secret Key"
                          id="api_key_test"
                          type="text"
                          value={data.credentials?.api_key ?? ""}
                          onChange={(e) => {
                            const value = e.target.value;
                            data.onChange(data.id, "credentials.api_key", value);
                            if (value) {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                api_key: false,
                              });
                            } else {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                api_key: true,
                              });
                            }
                          }}
                        />
                        {data.credentialErrors?.api_key && (
                          <span className="text-red-500 text-xs">Required</span>
                        )}
                        <InputField
                          variant="auth"
                          extra="mb-1"
                          label="Statement Descriptor"
                          placeholder="Statement Descriptor"
                          id="statement_descriptor_test"
                          type="text"
                          value={data.credentials?.statement_descriptor ?? ""}
                          onChange={(e) => {
                            const value = e.target.value;
                            data.onChange(data.id, "credentials.statement_descriptor", value);
                            // if (value) {
                            //   data.onChange(data.id, "credentialErrors", {
                            //     ...data.credentialErrors,
                            //     statement_descriptor: false,
                            //   });
                            // } else {
                            //   data.onChange(data.id, "credentialErrors", {
                            //     ...data.credentialErrors,
                            //     statement_descriptor: true,
                            //   });
                            // }
                          }}
                        />
                        {/* {data.credentialErrors?.statement_descriptor && (
                          <span className="text-red-500 text-xs">Required</span>
                        )} */}
                        <InputField
                          variant="auth"
                          extra="mb-1"
                          label="Statement Descriptor Suffix"
                          placeholder="Statement Descriptor Suffix"
                          id="statement_descriptor_suffix_test"
                          type="text"
                          value={data.credentials?.statement_descriptor_suffix ?? ""}
                          onChange={(e) => {
                            const value = e.target.value;
                            data.onChange(data.id, "credentials.statement_descriptor_suffix", value);
                            // if (value) {
                            //   data.onChange(data.id, "credentialErrors", {
                            //     ...data.credentialErrors,
                            //     statement_descriptor_suffix: false,
                            //   });
                            // } else {
                            //   data.onChange(data.id, "credentialErrors", {
                            //     ...data.credentialErrors,
                            //     statement_descriptor_suffix: true,
                            //   });
                            // }
                          }}
                        />
                        {/* {data.credentialErrors?.statement_descriptor_suffix && (
                          <span className="text-red-500 text-xs">Required</span>
                        )} */}
                      </div>
                    </>
                  ) : data.gateway === 'e95cb998-9a85-4a3d-b90d-5685fa662488' || data.gateway === '2615c804-0b38-455b-a82c-fc5b5061c364' ? (
                    <>
                      <div  key={data.id}  className="relative mt-5 max-h-[calc(100vh-300px)] overflow-auto overflow-x-hidden rounded-xl border border-gray-200 bg-white p-5 shadow-3xl shadow-shadow-500 scrollbar-thin scrollbar-track-gray-100 scrollbar-thumb-gray-300 dark:!border-white/10 dark:bg-navy-800 dark:shadow-none">  
                        <InputField
                          variant="auth"
                          extra="mb-1"
                          label="Secret Key*"
                          placeholder="Secret Key"
                          id="secret_key_test"
                          type="text"
                          value={data.credentials?.secret_key ?? ""}
                          onChange={(e) => {
                            const value = e.target.value;
                            data.onChange(data.id, "credentials.secret_key", value);
                            if (value) {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                secret_key: false,
                              });
                            } else {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                secret_key: true,
                              });
                            }
                          }}
                        />
                        {data.credentialErrors?.secret_key && (
                          <span className="text-red-500 text-xs">Required</span>
                        )}
                      </div>
                    </>
                  ) : data.gateway === '03315e64-86e9-4871-8d4f-d28e40b857c0' || data.gateway === 'a059c401-1e01-4d82-9864-6a7b805db6d8' ? (
                    <>
                      <div  key={data.id}  className="relative mt-5 max-h-[calc(100vh-300px)] overflow-auto overflow-x-hidden rounded-xl border border-gray-200 bg-white p-5 shadow-3xl shadow-shadow-500 scrollbar-thin scrollbar-track-gray-100 scrollbar-thumb-gray-300 dark:!border-white/10 dark:bg-navy-800 dark:shadow-none">  
                        <InputField
                          variant="auth"
                          extra="mb-1"
                          label="Secret Key*"
                          placeholder="Secret Key"
                          id="secret_key_test"
                          type="text"
                          value={data.credentials?.secret_key ?? ""}
                          onChange={(e) => {
                            const value = e.target.value;
                            data.onChange(data.id, "credentials.secret_key", value);
                            if (value) {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                secret_key: false,
                              });
                            } else {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                secret_key: true,
                              });
                            }
                          }}
                        />
                        {data.credentialErrors?.secret_key && (
                          <span className="text-red-500 text-xs">Required</span>
                        )}
                        <InputField
                          variant="auth"
                          extra="mb-1"
                          label="Brand ID*"
                          placeholder="Brand ID"
                          id="brand_id_test"
                          type="text"
                          value={data.credentials?.brand_id ?? ""}
                          onChange={(e) => {
                            const value = e.target.value;
                            data.onChange(data.id, "credentials.brand_id", value);
                            if (value) {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                brand_id: false,
                              });
                            } else {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                brand_id: true,
                              });
                            }
                          }}
                        />
                        {data.credentialErrors?.brand_id && (
                          <span className="text-red-500 text-xs">Required</span>
                        )}
                      </div>
                    </>
                  ) : data.gateway === '96bcc19b-db68-4b32-84d3-08549fb04b99' || data.gateway === '35e149f1-1a2c-4ec2-a6cc-8fc0d6bcdf87' ? (
                    <>
                      <div  key={data.id}  className="relative mt-5 max-h-[calc(100vh-300px)] overflow-auto overflow-x-hidden rounded-xl border border-gray-200 bg-white p-5 shadow-3xl shadow-shadow-500 scrollbar-thin scrollbar-track-gray-100 scrollbar-thumb-gray-300 dark:!border-white/10 dark:bg-navy-800 dark:shadow-none">  
                        <InputField
                          variant="auth"
                          extra="mb-1"
                          label="Api Key*"
                          placeholder="Api Key"
                          id="api_key_test"
                          type="text"
                          value={data.credentials?.api_key ?? ""}
                          onChange={(e) => {
                            const value = e.target.value;
                            data.onChange(data.id, "credentials.api_key", value);
                            if (value) {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                api_key: false,
                              });
                            } else {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                api_key: true,
                              });
                            }
                          }}
                        />
                        {data.credentialErrors?.api_key && (
                          <span className="text-red-500 text-xs">Required</span>
                        )}
                      </div>
                    </>
                  ) : data.gateway === 'd8fc67f8-2a9e-4aae-a77c-daf3c89e8777' || data.gateway === 'e3e30eee-36de-4a89-abcb-d05ced13e610' ? (
                    <>
                      <div  key={data.id}  className="relative mt-5 max-h-[calc(100vh-300px)] overflow-auto overflow-x-hidden rounded-xl border border-gray-200 bg-white p-5 shadow-3xl shadow-shadow-500 scrollbar-thin scrollbar-track-gray-100 scrollbar-thumb-gray-300 dark:!border-white/10 dark:bg-navy-800 dark:shadow-none">  
                        <InputField
                          variant="auth"
                          extra="mb-1"
                          label="Api Key*"
                          placeholder="Api Key"
                          id="api_key_test"
                          type="text"
                          value={data.credentials?.api_key ?? ""}
                          onChange={(e) => {
                            const value = e.target.value;
                            data.onChange(data.id, "credentials.api_key", value);
                            if (value) {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                api_key: false,
                              });
                            } else {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                api_key: true,
                              });
                            }
                          }}
                        />
                        {data.credentialErrors?.api_key && (
                          <span className="text-red-500 text-xs">Required</span>
                        )}
                        <InputField
                          variant="auth"
                          extra="mb-1"
                          label="Webhook Secret*"
                          placeholder="Webhook Secret"
                          id="webhook_secret_test"
                          type="text"
                          value={data.credentials?.webhook_secret ?? ""}
                          onChange={(e) => {
                            const value = e.target.value;
                            data.onChange(data.id, "credentials.webhook_secret", value);
                            if (value) {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                webhook_secret: false,
                              });
                            } else {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                webhook_secret: true,
                              });
                            }
                          }}
                        />
                        {data.credentialErrors?.webhook_secret && (
                          <span className="text-red-500 text-xs">Required</span>
                        )}
                      </div>
                    </>
                  ) : data.gateway === 'd9112e48-cd7b-4fc8-aa07-b38062a0a57f' || data.gateway === 'eaf4e383-3caf-4509-865c-4559ff1737a2' ? (
                    <>
                      <div  key={data.id}  className="relative mt-5 max-h-[calc(100vh-300px)] overflow-auto overflow-x-hidden rounded-xl border border-gray-200 bg-white p-5 shadow-3xl shadow-shadow-500 scrollbar-thin scrollbar-track-gray-100 scrollbar-thumb-gray-300 dark:!border-white/10 dark:bg-navy-800 dark:shadow-none">  
                        <InputField
                          variant="auth"
                          extra="mb-1"
                          label="Api Key*"
                          placeholder="Api Key"
                          id="api_key_test"
                          type="text"
                          value={data.credentials?.api_key ?? ""}
                          onChange={(e) => {
                            const value = e.target.value;
                            data.onChange(data.id, "credentials.api_key", value);
                            if (value) {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                api_key: false,
                              });
                            } else {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                api_key: true,
                              });
                            }
                          }}
                        />
                        {data.credentialErrors?.api_key && (
                          <span className="text-red-500 text-xs">Required</span>
                        )}
                        <InputField
                          variant="auth"
                          extra="mb-1"
                          label="Secret Key*"
                          placeholder="Secret Key"
                          id="secret_key_test"
                          type="text"
                          value={data.credentials?.secret_key ?? ""}
                          onChange={(e) => {
                            const value = e.target.value;
                            data.onChange(data.id, "credentials.secret_key", value);
                            if (value) {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                secret_key: false,
                              });
                            } else {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                secret_key: true,
                              });
                            }
                          }}
                        />
                        {data.credentialErrors?.secret_key && (
                          <span className="text-red-500 text-xs">Required</span>
                        )}
                      </div>
                    </>
                  ) : data.gateway === '162f8652-23e5-4890-b8e7-e34c43d6ab6d' || data.gateway === 'f3994099-aa66-4bcd-9105-0c529c06236b' ? (
                    <>
                      <div  key={data.id}  className="relative mt-5 max-h-[calc(100vh-300px)] overflow-auto overflow-x-hidden rounded-xl border border-gray-200 bg-white p-5 shadow-3xl shadow-shadow-500 scrollbar-thin scrollbar-track-gray-100 scrollbar-thumb-gray-300 dark:!border-white/10 dark:bg-navy-800 dark:shadow-none">  
                        <InputField
                          variant="auth"
                          extra="mb-1"
                          label="User Name *"
                          placeholder="User Name *"
                          id="user_name_test"
                          type="text"
                          value={data.credentials?.user_name ?? ""}
                          onChange={(e) => {
                            const value = e.target.value;
                            data.onChange(data.id, "credentials.user_name", value);
                            if (value) {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                user_name: false,
                              });
                            } else {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                user_name: true,
                              });
                            }
                          }}
                        />
                        {data.credentialErrors?.user_name && (
                          <span className="text-red-500 text-xs">Required</span>
                        )}
                        <InputField
                          variant="auth"
                          extra="mb-1"
                          label="Password*"
                          placeholder="Password"
                          id="password_test"
                          type="text"
                          value={data.credentials?.password ?? ""}
                          onChange={(e) => {
                            const value = e.target.value;
                            data.onChange(data.id, "credentials.password", value);
                            if (value) {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                password: false,
                              });
                            } else {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                password: true,
                              });
                            }
                          }}
                        />
                        {data.credentialErrors?.password && (
                          <span className="text-red-500 text-xs">Required</span>
                        )}
                        <InputField
                          variant="auth"
                          extra="mb-1"
                          label="Member ID *"
                          placeholder="Member ID "
                          id="member_id_test"
                          type="text"
                          value={data.credentials?.member_id ?? ""}
                          onChange={(e) => {
                            const value = e.target.value;
                            data.onChange(data.id, "credentials.member_id", value);
                            if (value) {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                member_id: false,
                              });
                            } else {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                member_id: true,
                              });
                            }
                          }}
                        />
                        {data.credentialErrors?.member_id && (
                          <span className="text-red-500 text-xs">Required</span>
                        )}
                        <InputField
                          variant="auth"
                          extra="mb-1"
                          label="Secure Key *"
                          placeholder="Secure Key "
                          id="secure_key_test"
                          type="text"
                          value={data.credentials?.secure_key ?? ""}
                          onChange={(e) => {
                            const value = e.target.value;
                            data.onChange(data.id, "credentials.secure_key", value);
                            if (value) {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                secure_key: false,
                              });
                            } else {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                secure_key: true,
                              });
                            }
                          }}
                        />
                        {data.credentialErrors?.secure_key && (
                          <span className="text-red-500 text-xs">Required</span>
                        )}
                        <InputField
                          variant="auth"
                          extra="mb-1"
                          label="Terminal ID *"
                          placeholder="Terminal ID "
                          id="terminal_id_test"
                          type="text"
                          value={data.credentials?.terminal_id ?? ""}
                          onChange={(e) => {
                            const value = e.target.value;
                            data.onChange(data.id, "credentials.terminal_id", value);
                            if (value) {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                terminal_id: false,
                              });
                            } else {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                terminal_id: true,
                              });
                            }
                          }}
                        />
                        {data.credentialErrors?.terminal_id && (
                          <span className="text-red-500 text-xs">Required</span>
                        )}
                        <InputField
                          variant="auth"
                          extra="mb-1"
                          label="Partner ID *"
                          placeholder="Partner ID "
                          id="partner_id_test"
                          type="text"
                          value={data.credentials?.partner_id ?? ""}
                          onChange={(e) => {
                            const value = e.target.value;
                            data.onChange(data.id, "credentials.partner_id", value);
                            if (value) {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                partner_id: false,
                              });
                            } else {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                partner_id: true,
                              });
                            }
                          }}
                        />
                        {data.credentialErrors?.partner_id && (
                          <span className="text-red-500 text-xs">Required</span>
                        )}
                        <InputField
                          variant="auth"
                          extra="mb-1"
                          label="Descriptor *"
                          placeholder="Descriptor "
                          id="descriptor_test"
                          type="text"
                          value={data.credentials?.descriptor ?? ""}
                          onChange={(e) => {
                            const value = e.target.value;
                            data.onChange(data.id, "credentials.descriptor", value);
                            if (value) {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                descriptor: false,
                              });
                            } else {
                              data.onChange(data.id, "credentialErrors", {
                                ...data.credentialErrors,
                                descriptor: true,
                              });
                            }
                          }}
                        />
                        {data.credentialErrors?.descriptor && (
                          <span className="text-red-500 text-xs">Required</span>
                        )}
                      </div>
                    </>
                  ) : (
                    null
                  )}
                </div>
              )}
            </div>
         )}
        </>
      ) : data.action === 'process_with_last_success' ? ( 
        data.gateways.length > 0 ?  (
        <>
          <p className="text-xs">Set the priority of the gateway</p>

          {(data.successGateways ?? []).map((gate: any, index: number) => (
            <div
              key={gate.id}
              className="flex items-center justify-between rounded border p-2 mb-2 bg-white"
            >
              <span className="font-semibold">
                {index + 1}. {gate.name}
              </span>

              <div className="flex gap-2">
                <button
                  disabled={index === 0}
                  onClick={() => {
                    const reordered = moveUp(data.successGateways, index);
                    data.onChange(data.id, "successGateways", reordered);
                    data.onChange(
                      data.id,
                      "gateway",
                      reordered.map((g: any) => g.id)
                    );
                  }}
                  className="px-2 py-1 text-xs border rounded disabled:opacity-50"
                >
                  ↑
                </button>

                <button
                  disabled={index === data.successGateways.length - 1}
                  onClick={() => {
                    const reordered = moveDown(data.successGateways, index);
                    data.onChange(data.id, "successGateways", reordered);
                    data.onChange(
                      data.id,
                      "gateway",
                      reordered.map((g: any) => g.id)
                    );
                  }}
                  className="px-2 py-1 text-xs border rounded disabled:opacity-50"
                >
                  ↓
                </button>
              </div>
            </div>
          ))}
        </>
        ) : ( 
          <>
            <p className="text-xs">There are no any gateway activated into client profile</p>
          </>
        )
      ) : data.action === 'process_with_priority' ? (
        data.gateways.length > 0 ?  (
        <>
          <p className="text-xs">Set the priority of the gateway</p>

          {(data.gateways ?? []).map((gate: any, index: number) => (
            <div
              key={gate.id}
              className="flex items-center justify-between rounded border p-2 mb-2 bg-white"
            >
              <span className="font-semibold">
                {index + 1}. {gate.name}
              </span>

              <div className="flex gap-2">
                <button
                  disabled={index === 0}
                  onClick={() => {
                    const reordered = moveUp(data.gateways, index);
                    data.onChange(data.id, "gateways", reordered);
                    data.onChange(
                      data.id,
                      "gateway",
                      reordered.map((g: any) => g.id)
                    );
                  }}
                  className="px-2 py-1 text-xs border rounded disabled:opacity-50"
                >
                  ↑
                </button>

                <button
                  disabled={index === data.gateways.length - 1}
                  onClick={() => {
                    const reordered = moveDown(data.gateways, index);
                    data.onChange(data.id, "gateways", reordered);
                    data.onChange(
                      data.id,
                      "gateway",
                      reordered.map((g: any) => g.id)
                    );
                  }}
                  className="px-2 py-1 text-xs border rounded disabled:opacity-50"
                >
                  ↓
                </button>
              </div>
            </div>
          ))}
        </>
        ) : ( 
          <>
            <p className="text-xs">There are no any gateway activated into client profile</p>
          </>
        )
      ) : data.action === 'process_transaction_with_status' ? ( 
        <>
          <div className="w-100">
            <select
              className="w-full border rounded px-2 py-1 text-sm"
              value={data.gateway}
              onChange={(e) =>  {
                data.onChange(data.id, "gateway", e.target.value)
                data.onChange(data.id, "hasGatewayError", false)
              }}
            >
              <option value="">Select Gateway</option>
              {(data.gateways ?? []).map((gate: any) => (
                <option key={gate?.id} value={gate?.id}>
                  {gate?.name}
                </option>
              ))}
            </select>
            {data.hasGatewayError && (<span className="text-red-500 text-xs">Required</span>)}
          </div>
          <div className="w-100">
            <select
              className="w-full border rounded px-2 py-1 text-sm"
              value={data.status}
              onChange={(e) =>  {
                data.onChange(data.id, "status", e.target.value)
                data.onChange(data.id, "hasStatusError", false)
              }}
            >
              <option value="">Select Status</option>
              <option value="ERRORED">ERRORED</option>
              <option value="REJECTED">REJECTED</option>
              <option value="FAILED">FAILED</option>
            </select>
            {data.hasStatusError && (<span className="text-red-500 text-xs">Required</span>)}
          </div>
          <div className="w-100">
            <TextArea
              variant="auth"
              extra="mb-1 bg-white rounded-xl"
              label=""
              placeholder="Description"
              id="description_test"
              value={data.status_description ?? ""}
              onChange={(e) =>  {
                const value = e.target.value
                data.onChange(data.id, "status_description", e.target.value)
                if(value) {
                  data.onChange(data.id, "hasStatusDescriptionError", false)
                } else {
                  data.onChange(data.id, "hasStatusDescriptionError", true)
                }
              }}
            />
            {data.hasStatusDescriptionError && (<span className="text-red-500 text-xs">Required</span>)}
          </div>
        </>
      ): null}
      <Handle type="target" position={Position.Left} className="custom-handle-action"/>
    </div>
    </motion.div>
  )
};
const nodeTypes = {
  conditionNode,
  actionNode,
};

const FileDropzone = ({ label, onFileSelect , onRemoveFile  , resetKey}: { label: string; onFileSelect: (file: Record<string, any> | null) => void , onRemoveFile:any , resetKey?: any} ) => {
    const [fileName, setFileName] = useState("");
    const [isUploading, setIsUploading] = useState<boolean>(false);

    const onDrop = useCallback((acceptedFiles: File[]) => {
        const file = acceptedFiles[0];
        if (file) {
            setIsUploading(true);

            const allowedTypes = ["application/json", "text/json"];
            if (allowedTypes.includes(file.type)) {
                setFileName(file.name);
                const reader = new FileReader();
                reader.readAsText(file);
                reader.onload = () => {
                  try {
                    const json = JSON.parse(reader.result as string);
                    onFileSelect(json);
                  } catch (err) {
                    toast.error("Invalid JSON file");
                    onFileSelect(null);
                  }
                };
                setIsUploading(false);
            } else {
                toast.error("Only JSON files are allowed.");
                setFileName("");
                onFileSelect(null); 
                setIsUploading(false);
            }
        }
    }, [onFileSelect]);
    useEffect(() => {
        if (resetKey) {
        onRemoveFile(true);
        setFileName("");
        onFileSelect(null); 
        }
    }, [resetKey]);
    const removeFile = () => {
        onRemoveFile(true);
        setFileName("");
        onFileSelect(null);
    };

    const { getRootProps, getInputProps } = useDropzone({
        onDrop,
        onDropRejected: (fileRejections) => {
            const rejection = fileRejections[0];
            if (rejection?.errors[0]?.code === 'file-too-large') {
                toast.error("File size must be less than 2MB");
            } else if (rejection?.errors[0]?.code === 'file-invalid-type') {
                toast.error("Only JSON files are allowed.");
            } else {
                toast.error("File upload failed. Please try again.");
            }
        },
        accept: {
          "application/json": [".json"],
        },
        maxSize: 5 * 1024 * 1024,
        multiple: false,
    });
    return (
        <div
            {...getRootProps()}
            className={`flex flex-col items-center justify-center p-6 border-2 border-dashed rounded-xl cursor-pointer w-full h-36 shadow-lg relative transition-all duration-300 border-gray-400/30 bg-white/70 dark:bg-gray-800/70 hover:border-blue-500 hover:shadow-xl`}
        >
            <input {...getInputProps()} />
            {isUploading ? (
              <div className="flex flex-col items-center justify-center">
                  <DivLoader className="h-8 w-8 border-blue-500" />
                  <p className="text-gray-600 text-sm dark:text-gray-300 font-medium mt-3">Processing JSON...</p>
              </div>
            ): fileName  ? (
                <div className="relative flex items-center gap-2">
                    <FiUploadCloud className="text-green-600 text-xl" />
                    <span className="text-sm dark:text-white">{fileName}</span>
                    <button
                    onClick={(e) => {
                        e.stopPropagation();
                        removeFile();
                    }}
                    className="ml-2 bg-red-500 text-white rounded-full p-1 hover:bg-red-600 transition-all"
                    >
                    <FiXCircle className="text-sm" />
                    </button>
                </div>
            ) : (
                <div className="flex flex-col items-center">
                    <FiUploadCloud
                        className={`text-4xl mb-3 transition-transform duration-300  text-blue-500 hover:scale-110`}
                    />
                    <p className="text-gray-600 text-sm dark:text-gray-300 font-medium">{label}</p>
                </div>
            )}
        </div>
    );
};

export default function FlowChart() {
  const [nodes, setNodes, onNodesChange] = useNodesState([]);
  const [edges, setEdges, onEdgesChange] = useEdgesState([]);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isOpenImport, setIsOpenImport] = useState(false);
  const [isCloseModal, setIsCloseModal] =  useState<boolean>(false);
  const [isCloseImportModal, setIsCloseImportModal] =  useState<boolean>(false);
  const [createdJson, setJSON] = useState("");
  const [copyJson, setCopyJson] = React.useState<boolean>(false)
  const [isLoading, setLoading] = useState<boolean>(false);
  const [isSubmitLoading, setSubmitLoading] = useState<boolean>(false);
  const prams = useParams();
  const [paymentGateway, setPaymentGateway] = useState<string>("");
  const [successPaymentGateway, setSuccessPaymentGateway] = useState<string>("");
  const [storeDropDownData, setStoreDropDownData] = useState([]);
  const [storeSuccessDropDownData, setStoreSuccessDropDownData] = useState([]);
  const { singleRoleData, setSingleRoleData } = useContext(ClientContext);
  const { id: clientId } = prams;
  const [formValuesErr, setFormValuesErr] =useState("");
  const [jsonFile, setJsonFile] = useState<Record<string, any> | null>(null);
  const [jsonText, setJsonText] = useState<any>("");
  const [removeFile,setRemoveFile] = useState(false)
  const [resetKey, setResetKey] = useState(0);
  const [uploadFileType, setUploadFileType] = useState<boolean>(false);
  const [isImportLoading , setIsImportLoading] = useState<boolean>(false);

  const addCondition = (nodeId: string) => {
    const allKeys = [
      "amount",
      "geo-location",
      "card-type",
      "currency",
      "time",
      "day",
      "card-bin",
    ];

    setNodes((nds) =>
      nds.map((node) => {
        if (node.id !== nodeId) return node;

        const usedKeys = node.data.conditions.map((c: any) => c.key);
        const nextKey = allKeys.find((k) => !usedKeys.includes(k));
        if (!nextKey) return node;

        return {
          ...node,
          data: {
            ...node.data,
            conditions: [
              ...node.data.conditions,
              { key: "", operator: "", value: "" },
            ],
          },
        };
      })
    );
  };
  const removeCondition = (nodeId: string, index: number) => {
    setNodes((nds) =>
      nds.map((node) =>
        node.id === nodeId
          ? {
              ...node,
              data: {
                ...node.data,
                conditions: node.data.conditions.filter(
                  (_: any, i: number) => i !== index
                ),
              },
            }
          : node
      )
    );
  };
  const enhanceNodeData = (node: Node): Node => {
    if (node.type === "conditionNode") {
      return {
        ...node,
        data: {
          ...node.data,
          onChange: updateNodeData,
          onRemove: removeNode,
          addCondition,
          removeCondition,
        },
      };
    }
    if (node.type === "actionNode") {
      return {
        ...node,
        data: {
          ...node.data,
          onChange: updateNodeData,
          onRemove: removeNode,
        },
      };
    }
    return node;
  };
  const handleClose = () => {
    setIsCloseModal(true);
    setTimeout(() => {
      setIsCloseModal(false);
      onClose();
    }, 300);
  };
  const updateNodeData = (
    id: string,
    field: string,
    value: any,
    index?: number
  ) => {
    setNodes((nds) =>
      nds.map((node) => {
        if (node.id !== id) return node;

        const updatedData = { ...node.data };

        if (typeof index === "number") {
          const updatedConditions = [...(updatedData.conditions || [])];

          updatedConditions[index] = {
            ...updatedConditions[index],
            [field]: value,
          };

          return {
            ...node,
            data: {
              ...updatedData,
              conditions: updatedConditions,
            },
          };
        }

        if (field.includes(".")) {
          const keys = field.split(".");
          let current: any = updatedData;

          for (let i = 0; i < keys.length - 1; i++) {
            current[keys[i]] = { ...(current[keys[i]] || {}) };
            current = current[keys[i]];
          }

          current[keys[keys.length - 1]] = value;

          return {
            ...node,
            data: updatedData,
          };
        }

        updatedData[field] = value;

        return {
          ...node,
          data: updatedData,
        };
      })
    );
  };
  const addConditionNode = () => {
    // const newId = getId();
    const newId = crypto.randomUUID();
    const conditionCount = nodes.filter(
      (n) => n.type === "conditionNode"
    ).length;
    const newNode: Node = {
      id: newId,
      type: "conditionNode",
      position: { x: Math.random() * 300, y: Math.random() * 300 },
      data: {
        id: newId,
        titleIndex: conditionCount + 1,
        conditions: [
          { key: "", operator: "", value: "" },
        ],
        onChange: updateNodeData,
        onRemove: removeNode,
        addCondition: (id: string) => {
          const allKeys = [
            "amount",
            "geo-location",
            "card-type",
            "currency",
            "time",
            "day",
            "card-bin",
          ];
          setNodes((nds) => {
            const targetNode = nds.find((n) => n.id === id);
            if (!targetNode || !targetNode.data || !targetNode.data.conditions) return nds;
            const usedKeys = targetNode.data.conditions.map((c: any) => c.key);
            const nextKey = allKeys.find((k) => !usedKeys.includes(k)) || "";
            if (!nextKey) return nds;
            const newCondition = { key: "", operator: "", value: "" };
            return nds.map((node) =>
              node.id === id
                ? {
                    ...node,
                    data: {
                      ...node.data,
                      conditions: [...node.data.conditions, newCondition],
                    },
                  }
                : node
            );
          });
        },
        removeCondition: (id: string, index: number) => {
          setNodes((nds) =>
            nds.map((node) =>
              node.id === id
                ? { ...node, data: { ...node.data, conditions: node.data.conditions.filter((_condition: { field: string; operator: string; value: string }, i: number) => i !== index)
        } }
                : node
            )
          );
        },
      },
    };
    setNodes((nds) => [...nds, newNode]);
  };
  const addActionNode = () => {
    const newId = crypto.randomUUID();
    const newNode: Node = {
      id: newId,
      type: "actionNode",
      position: { x: Math.random() * 300 + 300, y: Math.random() * 300 },
      data: {
        id: newId,
        action: "process_with_gateway",
        gateway: paymentGateway,
        cred_type: "existing",
        credentials: {}, 
        status : "",
        status_description : "",
        gateways: storeDropDownData,
        successGateways: storeSuccessDropDownData,
        fetchSuccessGateways,
        fetchNormalGateways,
        onChange: updateNodeData,
        onRemove: removeNode,
      },
    };
    setNodes((nds) => [...nds, newNode]);
  };
  const onConnect = useCallback(
    (params: Edge | Connection) =>
      setEdges((eds) => addEdge({ ...params, animated: true, style: { stroke: "#2196f3" } }, eds)),
    []
  );
  const generateJSON = async (isSave = false) => {
    const isValid = validateConditions();
    if (!isValid) {
      toast.error("Please fill all required condition values");
      return;
    }
    const isValidAction = validateActions();
    if (!isValidAction) {
      toast.error("Please fill all required actions values");
      return;
    }
    const isValidActions = validateConditionsWithActions();
    if (!isValidActions) {
      toast.error("Each condition/action must be connected to exactly one action/condition. Some conditions/action are either not connected or connected to multiple actions/condition. Please update the connections to ensure each condition has one action/condition mapping.");
      return;
    }
    const groups: { [targetId: string]: string[] } = {};
    edges.forEach((edge: any) => {
      const { source, target } = edge;
      if (!groups[target]) groups[target] = [];
      groups[target].push(source);
    });
    const results: any[] = [];
    const processed = new Set();
    Object.entries(groups).forEach(([target, sources]) => {
      if (processed.has(target)) return;
      const targetNode = nodes.find((n) => n.id === target)?.data;
      const { action, gateway , cred_type , credentials , status , status_description } = targetNode || {};
      const sourceNodes = sources
        .map((sourceId) => nodes.find((n) => n.id === sourceId))
        .filter(Boolean);
      const conditions = sourceNodes.flatMap((n) =>
        (n?.data?.conditions || []).map((cond: any) => {
          if (
            (cond.key === "amount" || cond.key === "time") &&
            cond.operator === "between" &&
            cond.value1 !== undefined &&
            cond.value2 !== undefined
          ) {
            return {
              ...cond,
              value: `${cond.value1},${cond.value2}`,
              value1: undefined,
              value2: undefined,
            };
          }

          delete cond.hasKeyError;
          delete cond.hasOperatorError;
          delete cond.hasError;
          return cond;
        })
      );
      results.push({
        action: {
          action,
          gateway,
          ...(action === "process_with_gateway" && { cred_type }),
          ...(cred_type === "custom" && { credentials }),
          ...(action === "process_transaction_with_status" && { status }),
          ...(action === "process_transaction_with_status" && { status_description }),
        },
        condition: conditions,
      });
      processed.add(target);
    });
    setJSON(JSON.stringify(results, null, 2));
    if(!isSave) {
      onOpen();
    }

    return JSON.stringify(results, null, 2);
  };
  const importJSON = async (isSave = false) => {
    setIsOpenImport(true);
  }
  const handleImportClose = () => {
    setIsCloseImportModal(true);
    setTimeout(() => {
      setJsonFile(null)
      setJsonText("")
      setFormValuesErr("")
      setUploadFileType(false)
      setIsCloseImportModal(false);
      setIsOpenImport(false);
    }, 300);
  };
  const removeNode = (id: string) => {
    setNodes((nds) => nds.filter((node) => node.id !== id));
    setEdges((eds) => eds.filter((edge) => edge.source !== id && edge.target !== id));
  };
  const validateConditions = () => {
    let hasErrors = false;
    let hasKeyErrors = false;
    let hasOperatorErrors = false;
    const updatedNodes = nodes.map((node) => {
      if (node.type === "conditionNode") {
        const updatedConditions = node.data.conditions.map((condition: Condition) => {
          let isEmpty = false;
          let isEmptyKey = false;
          let isEmptyOperator = false;

          if(condition.key == "") {
            isEmptyKey = true;
          } 

          if(condition.operator == "") {
            isEmptyOperator = true;
          }
          if (condition.operator === 'between' && (condition.key === 'amount' || condition.key === 'time')) {
            if (typeof condition.value === 'string') {
              const [min, max] = condition.value.split(',');
              isEmpty = !min || !max;
            } else {
              isEmpty = true;
            }
          } else if (condition.operator === 'in' || condition.operator === 'not_in') {
            isEmpty = !condition.value || (Array.isArray(condition.value) && condition.value.length === 0);
          } else if (condition.key === 'card-bin') {
            const val = String(condition.value || "");
            isEmpty = val === "" || val.length !== 6 || !/^\d{6}$/.test(val);
          } else {
            isEmpty = !condition.value;
          }
          if (isEmpty) hasErrors = true;
          if (isEmptyKey) hasKeyErrors = true;
          if (isEmptyOperator) hasOperatorErrors = true;
          return { ...condition, hasError: isEmpty , hasKeyError : isEmptyKey , hasOperatorError : isEmptyOperator };
        });
        return {
          ...node,
          data: {
            ...node.data,
            conditions: updatedConditions,
          },
        };
      }
      return node;
    });
    setNodes(updatedNodes);
    return !hasErrors && !hasKeyErrors && !hasOperatorErrors;
  };
  const validateActions = () => {
    let hasErrors = false;

    const updatedNodes = nodes.map((node) => {
      if (node.type !== "actionNode") return node;

      console.log(node.data)
      const isActionEmpty = !node.data.action;
      const isGatewayEmpty = !node.data.gateway;

      let isStatusEmpty = false;
      let isStatusDescriptionEmpty = false;

      let credentialErrors: any = {};

      if (node.data.cred_type === "custom") {
        if(node.data.gateway === '861afd0f-523a-4ce2-8b23-443c604feb2c' || node.data.gateway === 'eb4c5a8e-7ba1-4740-9535-0d8b72ff0e1d') {
          const creds = node.data.credentials || {};

          if (!creds.public_api_key)
            credentialErrors.public_api_key = true;

          if (!creds.private_key)
            credentialErrors.private_key = true;

          if (!creds.provider)
            credentialErrors.provider = true;

          if (!creds.wallet_address)
            credentialErrors.wallet_address = true;

          if (!creds.to_currency)
            credentialErrors.to_currency = true;

          if (Object.keys(credentialErrors).length > 0) {
            hasErrors = true;
          }
        }
        if(node.data.gateway === '7fbef566-cfd0-4d60-856e-3be5ac521eb8' || node.data.gateway === '4d10accf-1248-4ebf-a243-33e21ff37c90') {
          const creds = node.data.credentials || {};

          if (!creds.public_api_key)
            credentialErrors.public_api_key = true;

          if (!creds.private_key)
            credentialErrors.private_key = true;

          if (Object.keys(credentialErrors).length > 0) {
            hasErrors = true;
          }
        }
        if(node.data.gateway === '2bfead52-3440-4159-bbff-7a795dcddbe1' || node.data.gateway === '596c3855-0620-4135-bb1f-782f44a03785') {
          const creds = node.data.credentials || {};

          if (!creds.api_key)
            credentialErrors.api_key = true;

          if (!creds.api_secret)
            credentialErrors.api_secret = true;

          if (!creds.payment_method)
            credentialErrors.payment_method = true;

          if (!creds.payout_payment_method)
            credentialErrors.payout_payment_method = true;
          
          if (Object.keys(credentialErrors).length > 0) {
            hasErrors = true;
          }
        }
        if(node.data.gateway === '9df8db6d-dfa4-4a24-a0f7-e9d66c9be423' || node.data.gateway === 'e08fcfe1-164e-46aa-a758-57b0638f2875') {
          const creds = node.data.credentials || {};

          if (!creds.api_key)
            credentialErrors.api_key = true;

          if (!creds.api_secret)
            credentialErrors.api_secret = true;

          if (Object.keys(credentialErrors).length > 0) {
            hasErrors = true;
          }
        }
        if(node.data.gateway === '3b9c196c-fbe9-4356-be6a-eb3ebca5df24' || node.data.gateway === '9083143f-f488-4eaa-9f10-4580bb107ca6') {
          const creds = node.data.credentials || {};

          if (!creds.api_key)
            credentialErrors.api_key = true;

          if (!creds.api_id)
            credentialErrors.api_id = true;

          if (Object.keys(credentialErrors).length > 0) {
            hasErrors = true;
          }
        }
        if(node.data.gateway === 'bda2ba8d-bd2e-441c-acd6-44ab03794b0c' || node.data.gateway === '78151478-a258-4e9e-b91c-4f696c176ac1') {
          const creds = node.data.credentials || {};

          if (!creds.endpoint_id)
            credentialErrors.endpoint_id = true;

          if (!creds.merchant_key)
            credentialErrors.merchant_key = true;

          if (Object.keys(credentialErrors).length > 0) {
            hasErrors = true;
          }
        }
        if(node.data.gateway === 'ade468a9-a822-4c1d-a4f9-5bfb40ed842a' || node.data.gateway === 'ed068bb2-441e-4325-814c-a8c737f9c16d') {
          const creds = node.data.credentials || {};

          if (!creds.client_key)
            credentialErrors.client_key = true;

          if (!creds.password)
            credentialErrors.password = true;

          if (!creds.brand)
            credentialErrors.brand = true;

          if (!creds.payout_client_key)
            credentialErrors.payout_client_key = true;

          if (!creds.payout_password)
            credentialErrors.payout_password = true;

          if (!creds.payout_brand)
            credentialErrors.payout_brand = true;

          if (Object.keys(credentialErrors).length > 0) {
            hasErrors = true;
          }
        }
        if(node.data.gateway === 'c1f00345-f952-4d20-9f97-768f41cd6e2e') {
          const creds = node.data.credentials || {};

          if (!creds.api_key)
            credentialErrors.api_key = true;

          if (Object.keys(credentialErrors).length > 0) {
            hasErrors = true;
          }
        }
        if(node.data.gateway === 'e95cb998-9a85-4a3d-b90d-5685fa662488' || node.data.gateway === '2615c804-0b38-455b-a82c-fc5b5061c364') {
          const creds = node.data.credentials || {};

          if (!creds.secret_key)
            credentialErrors.secret_key = true;

          if (Object.keys(credentialErrors).length > 0) {
            hasErrors = true;
          }
        }
        if(node.data.gateway === '03315e64-86e9-4871-8d4f-d28e40b857c0' || node.data.gateway === 'a059c401-1e01-4d82-9864-6a7b805db6d8') {
          const creds = node.data.credentials || {};

          if (!creds.secret_key)
            credentialErrors.secret_key = true;

          if (!creds.brand_id)
            credentialErrors.brand_id = true;

          if (Object.keys(credentialErrors).length > 0) {
            hasErrors = true;
          }
        }
        if(node.data.gateway === '96bcc19b-db68-4b32-84d3-08549fb04b99' || node.data.gateway === '35e149f1-1a2c-4ec2-a6cc-8fc0d6bcdf87') {
          const creds = node.data.credentials || {};

          if (!creds.api_key)
            credentialErrors.api_key = true;

          if (Object.keys(credentialErrors).length > 0) {
            hasErrors = true;
          }
        }
        if(node.data.gateway === 'd8fc67f8-2a9e-4aae-a77c-daf3c89e8777' || node.data.gateway === 'e3e30eee-36de-4a89-abcb-d05ced13e610') {
          const creds = node.data.credentials || {};

          if (!creds.api_key)
            credentialErrors.api_key = true;

          if (!creds.webhook_secret)
            credentialErrors.webhook_secret = true;

          if (Object.keys(credentialErrors).length > 0) {
            hasErrors = true;
          }
        }
        if(node.data.gateway === 'd9112e48-cd7b-4fc8-aa07-b38062a0a57f' || node.data.gateway === 'eaf4e383-3caf-4509-865c-4559ff1737a2') {
          const creds = node.data.credentials || {};

          if (!creds.api_key)
            credentialErrors.api_key = true;

          if (!creds.secret_key)
            credentialErrors.secret_key = true;

          if (Object.keys(credentialErrors).length > 0) {
            hasErrors = true;
          }
        }
        if(node.data.gateway === 'f3994099-aa66-4bcd-9105-0c529c06236b' || node.data.gateway === '162f8652-23e5-4890-b8e7-e34c43d6ab6d') {
          const creds = node.data.credentials || {};

          if (!creds.user_name)
            credentialErrors.user_name = true;

          if (!creds.password)
            credentialErrors.password = true;

          if (!creds.member_id)
            credentialErrors.member_id = true;

          if (!creds.secure_key)
            credentialErrors.secure_key = true;

          if (!creds.terminal_id)
            credentialErrors.terminal_id = true;

          if (!creds.partner_id)
            credentialErrors.partner_id = true;

          if (!creds.descriptor)
            credentialErrors.descriptor = true;

          if (Object.keys(credentialErrors).length > 0) {
            hasErrors = true;
          }
        }
      }

      if (isActionEmpty || isGatewayEmpty) {
        hasErrors = true;
      }

      if (node.data.action === "process_transaction_with_status") {
        isStatusEmpty = !node.data.status;
        isStatusDescriptionEmpty = !node.data.status_description;
        if (isStatusEmpty || isStatusDescriptionEmpty) {
          hasErrors = true;
        }
      }
      return {
        ...node,
        data: {
          ...node.data,
          hasActionError: isActionEmpty,
          hasGatewayError: isGatewayEmpty,
          hasStatusError : isStatusEmpty,
          hasStatusDescriptionError : isStatusDescriptionEmpty,
          credentialErrors,
        },
      };
    });

    setNodes(updatedNodes);

    return !hasErrors;
  };
  const validateConditionsWithActions = () => {
    let hasErrors = false;

    const conditionNodes = nodes.filter(n => n.type === "conditionNode");
    const actionNodes = nodes.filter(n => n.type === "actionNode");

    conditionNodes.forEach((conditionNode) => {
      const connectedActionEdges = edges.filter(
        (edge) =>
          edge.source === conditionNode.id &&
          actionNodes.some((a) => a.id === edge.target)
      );

      if (connectedActionEdges.length !== 1) {
        hasErrors = true;
      }
    });

    actionNodes.forEach((actionNode) => {
      const incomingConditionEdges = edges.filter(
        (edge) =>
          edge.target === actionNode.id &&
          conditionNodes.some((c) => c.id === edge.source)
      );

      if (incomingConditionEdges.length === 0) {
        hasErrors = true;
      }
    });

    // nodes.map((node) => {
    //   if (node.type === "conditionNode") {
    //     const connectedActionEdges = edges.filter(
    //       (edge) =>
    //         edge.source === node.id &&
    //         nodes.find((n) => n.id === edge.target && n.type === "actionNode")
    //     );
    //     if (connectedActionEdges.length !== 1) {
    //       hasErrors = true;
    //     }
    //   }
    // });

    return !hasErrors;
  };
  const saveChanges = async() => {
    setSubmitLoading(true)
    const generated = await generateJSON(true);
    const isValid = validateConditions();
    const isValidAction = validateActions();
    const isValidActions = validateConditionsWithActions();
    if (isValid && isValidAction && isValidActions) {
      if(generated && JSON.parse(generated).length > 0) {
        const data = {
          route_info: JSON.parse(generated),
          route_nodes : nodes,
          route_edges : edges
        }
        const updateData = await createSmartRoutingNew(data,clientId);
        const result = updateData.data
        if (result) {
          setSubmitLoading(false)
          toast.success("Smart routing data saved successfully");
        } else {
          setSubmitLoading(false)
          toast.error("Error while saving the smart routing data!!");
        }
      } else {
        setSubmitLoading(false)
        toast.error("Invalid smart routing configuration !!");
      }
    } else {
      setSubmitLoading(false)
    }
   
  }
  const buildFlowFromJSON = (json: any[]) => {
    const newNodes: Node[] = [];
    const newEdges: Edge[] = [];
    const existingConditionCount = nodes.filter(
      (n) => n.type === "conditionNode"
    ).length;
    json.forEach((item, index) => {
      const itemIndex = existingConditionCount + index + 1;
      const actionNodeId = crypto.randomUUID();
      const conditionNodeId = crypto.randomUUID();

      const isPriorityAction = item.action.action === "process_with_priority";
      const isSuccessAction = item.action.action === "process_with_last_success";

      let orderedGateways = storeDropDownData;
      let successOrderedGateways = storeSuccessDropDownData;

      if (isPriorityAction && Array.isArray(item.action.gateway)) {
        const gatewayMap = new Map(
          storeDropDownData.map((g: any) => [g.id, g])
        );

        orderedGateways = item.action.gateway
          .map((id: string) => gatewayMap.get(id))
          .filter(Boolean);
      }

      if (isSuccessAction && Array.isArray(item.action.gateway)) {
        const gatewayMap = new Map(
          storeSuccessDropDownData.map((g: any) => [g.id, g])
        );

        successOrderedGateways = item.action.gateway
          .map((id: string) => gatewayMap.get(id))
          .filter(Boolean);
      }

      newNodes.push({
        id: actionNodeId,
        type: "actionNode",
        position: { x: 600, y: index * 180 },
        data: {
          id: actionNodeId,
          action: item.action.action,
          gateway: item.action.gateway,
          gateways: orderedGateways,
          successGateways :
            item.action.action === "process_with_last_success"
              ? successOrderedGateways
              : storeSuccessDropDownData,
          fetchSuccessGateways,
          fetchNormalGateways,
          onChange: updateNodeData,
          onRemove: removeNode,
          ...(item.action.action === "process_with_gateway" && {
            cred_type: item.action.cred_type ?? "existing",
          }),
          ...(item.action.action === "process_with_gateway" && item.action.cred_type === "custom" && {
            credentials: item.action.credentials ?? {},
          }),
          ...(item.action.action === "process_transaction_with_status" && {
            status: item.action.status ?? "",
          }),
          ...(item.action.action === "process_transaction_with_status" && {
            status_description: item.action.status_description ?? "",
          }),
        },
      });

      newNodes.push({
        id: conditionNodeId,
        type: "conditionNode",
        position: { x: 150, y: index * 180 },
        data: {
          id: conditionNodeId,
          titleIndex: itemIndex,
          conditions: item.condition.map((c: any) => ({
            key: c.key,
            operator: c.operator,
            value: c.value,
          })),
          onChange: updateNodeData,
          onRemove: removeNode,
          addCondition,
          removeCondition,
        },
      });

      newEdges.push({
        id: `e-${conditionNodeId}-${actionNodeId}`,
        source: conditionNodeId,
        target: actionNodeId,
        animated: true,
        style: { stroke: "#2196f3" },
      });
    });

    setNodes((prev) => [...prev, ...newNodes]);
    setEdges((prev) => [...prev, ...newEdges]);

  };
  const TIME_REGEX = /^([01]\d|2[0-3]):([0-5]\d)$/;
  const normalize = (v: string) => v.toLowerCase();
  const validateImportedJSON = (data: any[]) => {
    if (!Array.isArray(data)) {
      throw new Error("Root JSON must be an array");
    }
    data.forEach((item, index) => {
      if (!item.action || typeof item.action !== "object") {
        throw new Error(`Item ${index + 1}: action object is required`);
      }
      if (!ALLOWED_ACTIONS.includes(item.action.action)) {
        if(item.action.action == "") {
          throw new Error(
            `Item ${index + 1}: Action is required`
          );
        } else {
          throw new Error(
            `Item ${index + 1}: Invalid action "${item.action.action}"`
          );
        }
      }
      
      const actionType = item.action.action;
      const gateway = item.action.gateway;
      const gatewayId = item.action.gateway;
      
      if (actionType === "process_with_priority" || actionType === "process_with_last_success") {
        if (gateway === undefined || gateway === null) {
          throw new Error(
            `Item ${index + 1}: Gateway priority is required`
          );
        }
        if (!Array.isArray(gateway)) {
          throw new Error(
            `Item ${index + 1}: Gateway priority must be an array`
          );
        }
        if (gateway.length === 0) {
          throw new Error(
            `Item ${index + 1}: Gateway priority must not be empty`
          );
        }
      } else if (actionType === "process_with_gateway") {
        const cred_type = item.action.cred_type;

        if (gateway === undefined || gateway === null || gateway === "") {
          throw new Error(
            `Item ${index + 1}: Gateway is required`
          );
        }
        if (typeof gateway !== "string") {
          throw new Error(
            `Item ${index + 1}: Gateway must be a string`
          );
        }
        if(cred_type === undefined || cred_type === null || cred_type.trim() === "") {
          throw new Error(
            `Item ${index + 1}: Cred type is required`
          );
        }
        if(
          gateway === "861afd0f-523a-4ce2-8b23-443c604feb2c" || 
          gateway === 'eb4c5a8e-7ba1-4740-9535-0d8b72ff0e1d' || 
          gateway === '7fbef566-cfd0-4d60-856e-3be5ac521eb8' || 
          gateway === '4d10accf-1248-4ebf-a243-33e21ff37c90' ||
          gateway === '2bfead52-3440-4159-bbff-7a795dcddbe1' ||
          gateway === '596c3855-0620-4135-bb1f-782f44a03785' ||
          gateway === '9df8db6d-dfa4-4a24-a0f7-e9d66c9be423'   ||
          gateway === 'e08fcfe1-164e-46aa-a758-57b0638f2875' ||
          gateway === '3b9c196c-fbe9-4356-be6a-eb3ebca5df24' ||
          gateway === '9083143f-f488-4eaa-9f10-4580bb107ca6' ||
          gateway === 'bda2ba8d-bd2e-441c-acd6-44ab03794b0c' || 
          gateway === '78151478-a258-4e9e-b91c-4f696c176ac1' ||
          gateway === 'ade468a9-a822-4c1d-a4f9-5bfb40ed842a' ||
          gateway === 'ed068bb2-441e-4325-814c-a8c737f9c16d' ||
          gateway === 'c1f00345-f952-4d20-9f97-768f41cd6e2e' ||
          gateway === 'e95cb998-9a85-4a3d-b90d-5685fa662488' ||
          gateway === '2615c804-0b38-455b-a82c-fc5b5061c364' ||
          gateway === '03315e64-86e9-4871-8d4f-d28e40b857c0' ||
          gateway === 'a059c401-1e01-4d82-9864-6a7b805db6d8' ||
          gateway === '96bcc19b-db68-4b32-84d3-08549fb04b99' ||
          gateway === '35e149f1-1a2c-4ec2-a6cc-8fc0d6bcdf87' ||
          gateway === 'd8fc67f8-2a9e-4aae-a77c-daf3c89e8777' ||
          gateway === 'e3e30eee-36de-4a89-abcb-d05ced13e610' ||
          gateway === 'd9112e48-cd7b-4fc8-aa07-b38062a0a57f' ||
          gateway === 'eaf4e383-3caf-4509-865c-4559ff1737a2' ||
          gateway === '162f8652-23e5-4890-b8e7-e34c43d6ab6d' ||
          gateway === 'f3994099-aa66-4bcd-9105-0c529c06236b' 
        ) {
          if (!["existing", "custom"].includes(cred_type)) {
            throw new Error(
              `Item ${index + 1}: Invalid cred type "${cred_type}" it must be existing or custom`
            );
          }
        } else {
          if(cred_type !== "existing") {
            throw new Error(
              `Item ${index + 1}: Invalid cred type "${cred_type}" it must be existing`
            );
          }
        }

        if(gateway === "861afd0f-523a-4ce2-8b23-443c604feb2c" || gateway === 'eb4c5a8e-7ba1-4740-9535-0d8b72ff0e1d') {
          if(cred_type == "custom") {
            const credentials = item.action.credentials;
            if (!credentials || typeof credentials !== "object") {
              throw new Error(
                `Item ${index + 1}: Credentials object is required for custom cred type`
              );
            }
            const requiredFields = [
              "public_api_key",
              "private_key",
              "provider",
              "wallet_address",
              "to_currency",
            ];

            const ALLOWED_PROVIDERS = [
              "banxa",
              "moonpay",
              "transak",
              "wert",
              "skrill_crypto",
            ];

            for (const field of requiredFields) {
              if (
                credentials[field] === undefined ||
                credentials[field] === null ||
                credentials[field] === ""
              ) {
                throw new Error(
                  `Item ${index + 1}: "${field}" is required in credentials`
                );
              }
            }

            if (!ALLOWED_PROVIDERS.includes(credentials.provider)) {
              throw new Error(
                `Item ${index + 1}: Invalid provider "${credentials.provider}". Allowed values: ${ALLOWED_PROVIDERS.join(", ")}`
              );
            }
          }
        }
        if(gateway === "7fbef566-cfd0-4d60-856e-3be5ac521eb8" || gateway === '4d10accf-1248-4ebf-a243-33e21ff37c90') {
          if(cred_type == "custom") {
            const credentials = item.action.credentials;
            if (!credentials || typeof credentials !== "object") {
              throw new Error(
                `Item ${index + 1}: Credentials object is required for custom cred type`
              );
            }
            const requiredFields = [
              "public_api_key",
              "private_key"
            ];
            for (const field of requiredFields) {
              if (
                credentials[field] === undefined ||
                credentials[field] === null ||
                credentials[field] === ""
              ) {
                throw new Error(
                  `Item ${index + 1}: "${field}" is required in credentials`
                );
              }
            }
          }
        }
        if(gateway === "2bfead52-3440-4159-bbff-7a795dcddbe1" || gateway === '596c3855-0620-4135-bb1f-782f44a03785') {
          if(cred_type == "custom") {
            const credentials = item.action.credentials;
            if (!credentials || typeof credentials !== "object") {
              throw new Error(
                `Item ${index + 1}: Credentials object is required for custom cred type`
              );
            }
            const requiredFields = [
              "api_key",
              "api_secret",
              "payment_method",
              "payout_payment_method"
            ];
            for (const field of requiredFields) {
              if (
                credentials[field] === undefined ||
                credentials[field] === null ||
                credentials[field] === ""
              ) {
                throw new Error(
                  `Item ${index + 1}: "${field}" is required in credentials`
                );
              }
            }
          }
        }
        if(gateway === "9df8db6d-dfa4-4a24-a0f7-e9d66c9be423" || gateway === 'e08fcfe1-164e-46aa-a758-57b0638f2875') {
          if(cred_type == "custom") {
            const credentials = item.action.credentials;
            if (!credentials || typeof credentials !== "object") {
              throw new Error(
                `Item ${index + 1}: Credentials object is required for custom cred type`
              );
            }
            const requiredFields = [
              "api_key",
              "api_secret"
            ];
            for (const field of requiredFields) {
              if (
                credentials[field] === undefined ||
                credentials[field] === null ||
                credentials[field] === ""
              ) {
                throw new Error(
                  `Item ${index + 1}: "${field}" is required in credentials`
                );
              }
            }
          }
        }
        if(gateway === "3b9c196c-fbe9-4356-be6a-eb3ebca5df24" || gateway === '9083143f-f488-4eaa-9f10-4580bb107ca6') {
          if(cred_type == "custom") {
            const credentials = item.action.credentials;
            if (!credentials || typeof credentials !== "object") {
              throw new Error(
                `Item ${index + 1}: Credentials object is required for custom cred type`
              );
            }
            const requiredFields = [
              "api_id",
              "api_key"
            ];
            for (const field of requiredFields) {
              if (
                credentials[field] === undefined ||
                credentials[field] === null ||
                credentials[field] === ""
              ) {
                throw new Error(
                  `Item ${index + 1}: "${field}" is required in credentials`
                );
              }
            }
          }
        }
        if(gateway === "bda2ba8d-bd2e-441c-acd6-44ab03794b0c" || gateway === '78151478-a258-4e9e-b91c-4f696c176ac1') {
          if(cred_type == "custom") {
            const credentials = item.action.credentials;
            if (!credentials || typeof credentials !== "object") {
              throw new Error(
                `Item ${index + 1}: Credentials object is required for custom cred type`
              );
            }
            const requiredFields = [
              "endpoint_id",
              "merchant_key"
            ];
            for (const field of requiredFields) {
              if (
                credentials[field] === undefined ||
                credentials[field] === null ||
                credentials[field] === ""
              ) {
                throw new Error(
                  `Item ${index + 1}: "${field}" is required in credentials`
                );
              }
            }
          }
        }
        if(gateway === "ade468a9-a822-4c1d-a4f9-5bfb40ed842a" || gateway === 'ed068bb2-441e-4325-814c-a8c737f9c16d') {
          if(cred_type == "custom") {
            const credentials = item.action.credentials;
            if (!credentials || typeof credentials !== "object") {
              throw new Error(
                `Item ${index + 1}: Credentials object is required for custom cred type`
              );
            }
            const requiredFields = [
              "client_key",
              "password",
              "brand",
              "payout_client_key",
              "payout_password",
              "payout_brand"
            ];
            for (const field of requiredFields) {
              if (
                credentials[field] === undefined ||
                credentials[field] === null ||
                credentials[field] === ""
              ) {
                throw new Error(
                  `Item ${index + 1}: "${field}" is required in credentials`
                );
              }
            }
          }
        }
        if(gateway === 'c1f00345-f952-4d20-9f97-768f41cd6e2e') {
          if(cred_type == "custom") {
            const credentials = item.action.credentials;
            if (!credentials || typeof credentials !== "object") {
              throw new Error(
                `Item ${index + 1}: Credentials object is required for custom cred type`
              );
            }
            const requiredFields = [
              "api_key"
            ];
            for (const field of requiredFields) {
              if (
                credentials[field] === undefined ||
                credentials[field] === null ||
                credentials[field] === ""
              ) {
                throw new Error(
                  `Item ${index + 1}: "${field}" is required in credentials`
                );
              }
            }
          }
        }
        if(gateway === "e95cb998-9a85-4a3d-b90d-5685fa662488" || gateway === '2615c804-0b38-455b-a82c-fc5b5061c364') {
          if(cred_type == "custom") {
            const credentials = item.action.credentials;
            if (!credentials || typeof credentials !== "object") {
              throw new Error(
                `Item ${index + 1}: Credentials object is required for custom cred type`
              );
            }
            const requiredFields = [
              "secret_key"
            ];
            for (const field of requiredFields) {
              if (
                credentials[field] === undefined ||
                credentials[field] === null ||
                credentials[field] === ""
              ) {
                throw new Error(
                  `Item ${index + 1}: "${field}" is required in credentials`
                );
              }
            }
          }
        }
        if(gateway === "03315e64-86e9-4871-8d4f-d28e40b857c0" || gateway === 'a059c401-1e01-4d82-9864-6a7b805db6d8') {
          if(cred_type == "custom") {
            const credentials = item.action.credentials;
            if (!credentials || typeof credentials !== "object") {
              throw new Error(
                `Item ${index + 1}: Credentials object is required for custom cred type`
              );
            }
            const requiredFields = [
              "secret_key",
              "brand_id"
            ];
            for (const field of requiredFields) {
              if (
                credentials[field] === undefined ||
                credentials[field] === null ||
                credentials[field] === ""
              ) {
                throw new Error(
                  `Item ${index + 1}: "${field}" is required in credentials`
                );
              }
            }
          }
        }
        if(gateway === "96bcc19b-db68-4b32-84d3-08549fb04b99" || gateway === '35e149f1-1a2c-4ec2-a6cc-8fc0d6bcdf87') {
          if(cred_type == "custom") {
            const credentials = item.action.credentials;
            if (!credentials || typeof credentials !== "object") {
              throw new Error(
                `Item ${index + 1}: Credentials object is required for custom cred type`
              );
            }
            const requiredFields = [
              "api_key"
            ];
            for (const field of requiredFields) {
              if (
                credentials[field] === undefined ||
                credentials[field] === null ||
                credentials[field] === ""
              ) {
                throw new Error(
                  `Item ${index + 1}: "${field}" is required in credentials`
                );
              }
            }
          }
        }
        if(gateway === "d8fc67f8-2a9e-4aae-a77c-daf3c89e8777" || gateway === 'e3e30eee-36de-4a89-abcb-d05ced13e610') {
          if(cred_type == "custom") {
            const credentials = item.action.credentials;
            if (!credentials || typeof credentials !== "object") {
              throw new Error(
                `Item ${index + 1}: Credentials object is required for custom cred type`
              );
            }
            const requiredFields = [
              "api_key",
              "webhook_secret"
            ];
            for (const field of requiredFields) {
              if (
                credentials[field] === undefined ||
                credentials[field] === null ||
                credentials[field] === ""
              ) {
                throw new Error(
                  `Item ${index + 1}: "${field}" is required in credentials`
                );
              }
            }
          }
        }
        if(gateway === "d9112e48-cd7b-4fc8-aa07-b38062a0a57f" || gateway === 'eaf4e383-3caf-4509-865c-4559ff1737a2') {
          if(cred_type == "custom") {
            const credentials = item.action.credentials;
            if (!credentials || typeof credentials !== "object") {
              throw new Error(
                `Item ${index + 1}: Credentials object is required for custom cred type`
              );
            }
            const requiredFields = [
              "api_key",
              "secret_key"
            ];
            for (const field of requiredFields) {
              if (
                credentials[field] === undefined ||
                credentials[field] === null ||
                credentials[field] === ""
              ) {
                throw new Error(
                  `Item ${index + 1}: "${field}" is required in credentials`
                );
              }
            }
          }
        }
        if(gateway === "f3994099-aa66-4bcd-9105-0c529c06236b" || gateway === '162f8652-23e5-4890-b8e7-e34c43d6ab6d') {
          if(cred_type == "custom") {
            const credentials = item.action.credentials;
            if (!credentials || typeof credentials !== "object") {
              throw new Error(
                `Item ${index + 1}: Credentials object is required for custom cred type`
              );
            }
            const requiredFields = [
              "user_name",
              "password",
              "member_id",
              "secure_key",
              "terminal_id",
              "partner_id",
              "descriptor"
            ];
            for (const field of requiredFields) {
              if (
                credentials[field] === undefined ||
                credentials[field] === null ||
                credentials[field] === ""
              ) {
                throw new Error(
                  `Item ${index + 1}: "${field}" is required in credentials`
                );
              }
            }
          }
        }
      } else if (actionType === "process_transaction_with_status") {
        const status = item.action.status;
        const status_description = item.action.status_description;
        if (gateway === undefined || gateway === null || gateway === "") {
          throw new Error(
            `Item ${index + 1}: Gateway is required`
          );
        }
        if (typeof gateway !== "string") {
          throw new Error(
            `Item ${index + 1}: Gateway must be a string`
          );
        }
        if (typeof status !== "string") {
          throw new Error(
            `Item ${index + 1}: Status must be a string`
          );
        }
        if (status === undefined || status === null || status.trim() === "") {
          throw new Error(`Item ${index + 1}: Status is required`);
        }
        if (!["ERRORED", "REJECTED","FAILED"].includes(status)) {
          throw new Error(
            `Item ${index + 1}: Status "${status}" it must be ERRORED , REJECTED or FAILED`
          );
        }
        if (!status_description || status_description.trim() === "") {
          throw new Error(
            `Item ${index + 1}: Status Description is required`
          );
        }
      } else {
        if (gateway === undefined || gateway === null || gateway === "") {
          throw new Error(
            `Item ${index + 1}: Gateway is required`
          );
        }
        if (typeof gateway !== "string") {
          throw new Error(
            `Item ${index + 1}: Gateway must be a string`
          );
        }
      }

      const storeGatewayIds = new Set(
        storeDropDownData.map((g: any) => g.id)
      );

      const storeSuccessGatewayIds = new Set(
        storeSuccessDropDownData.map((g: any) => g.id)
      );
      if (actionType === "process_with_gateway") {
        if (!storeGatewayIds.has(gatewayId)) {
          throw new Error(
            `Item ${index + 1}: Gateway id is invalid!`
          );
        }
      }
      if (actionType === "process_with_priority") {
        const priorityGateways = gateway as string[];

        priorityGateways.forEach((gId: string, gIndex: number) => {
          if (!storeGatewayIds.has(gId)) {
            throw new Error(
              `Item ${index + 1}: Gateway priority ${gIndex + 1} id "${gId}" is invalid`
            );
          }
        });
      }
      if (actionType === "process_with_last_success") {
        const successGateways = gateway as string[];

        successGateways.forEach((gId: string, gIndex: number) => {
          if (!storeSuccessGatewayIds.has(gId)) {
            throw new Error(
              `Item ${index + 1}: Gateway priority ${gIndex + 1} id "${gId}" is invalid`
            );
          }
        });
      }

      if (!Array.isArray(item.condition) || item.condition.length === 0) {
        throw new Error(`Item ${index + 1}: condition must be a non-empty array`);
      }

      const usedConditionKeys = new Set<string>();

      item.condition.forEach((cond: any, cIndex: number) => {

        if (!cond.key || cond.key === "") {
          throw new Error(
            `Item ${index + 1}: Condition ${cIndex + 1}: Key is required`
          );
        }

        if (usedConditionKeys.has(cond.key)) {
          throw new Error(
            `Item ${index + 1}: Condition "${cond.key}" is duplicated`
          );
        }

        usedConditionKeys.add(cond.key);
        
        const rule = CONDITION_RULES[cond.key];
        if (!rule) {
          throw new Error(
            `Item ${index + 1}, Condition ${cIndex + 1}: Invalid key "${cond.key}"`
          );
        }

        if (!rule.operators.includes(cond.operator)) {
          if(cond.operator == "") {
            throw new Error(
              `Item ${index + 1}: Condition ${cIndex + 1}: Operator is required for "${cond.key}"`
            );
          } else {
            throw new Error(
              `Item ${index + 1}, Condition ${cIndex + 1}: Invalid operator "${cond.operator}" for "${cond.key}"`
            );
          }
        }
        switch (rule.valueType) {
          case "number":
            if (cond.value === "" || cond.value === null || cond.value === undefined) {
              throw new Error(
                `Item ${index + 1}, Condition ${cIndex + 1}: Value is required`
              );
            }

            if (cond.operator === "between") {
              const [min, max] = String(cond.value).split(",");
              if (
                !min ||
                !max ||
                isNaN(Number(min)) ||
                isNaN(Number(max))
              ) {
                throw new Error(
                  `Item ${index + 1}, Condition ${cIndex + 1}: Value must be "min,max"`
                );
              }
            } else if (isNaN(Number(cond.value))) {
              throw new Error(
                `Item ${index + 1}, Condition ${cIndex + 1}: Value must be numeric`
              );
            }
            break;

          case "string":
            if (
              cond.value === "" ||
              cond.value === null ||
              cond.value === undefined ||
              (Array.isArray(cond.value) && cond.value.length === 0)
            ) {
              throw new Error(
                `Item ${index + 1}, Condition ${cIndex + 1}: Value is required`
              );
            }

            if (cond.operator === "in" || cond.operator === "not_in") {
              if (!Array.isArray(cond.value)) {
                throw new Error(
                  `Item ${index + 1}, Condition ${cIndex + 1}: Value must be an array`
                );
              }

              cond.value.forEach((v: string) => {
                if (
                  rule.allowedValues &&
                  !rule.allowedValues.map(normalize).includes(normalize(v))
                ) {
                  throw new Error(
                    `Item ${index + 1}, Condition ${cIndex + 1}: Invalid value "${v}"`
                  );
                }
              });
            } else {
              if (
                rule.allowedValues &&
                !rule.allowedValues.map(normalize).includes(normalize(cond.value))
              ) {
                throw new Error(
                  `Item ${index + 1}, Condition ${cIndex + 1}: Invalid value "${cond.value}"`
                );
              }
            }
            break;

          case "time":
            if (cond.value === "" || cond.value === null || cond.value === undefined) {
              throw new Error(
                `Item ${index + 1}, Condition ${cIndex + 1}: Value is required`
              );
            }

            if (cond.operator === "between") {
              const [start, end] = String(cond.value).split(",");
              if (!TIME_REGEX.test(start) || !TIME_REGEX.test(end)) {
                throw new Error(
                  `Item ${index + 1}, Condition ${cIndex + 1}: Invalid time range`
                );
              }
            } else if (!TIME_REGEX.test(String(cond.value))) {
              throw new Error(
                `Item ${index + 1}, Condition ${cIndex + 1}: Invalid time format (HH:mm)`
              );
            }
            break;

          case "card-bin":
            if (cond.value === "" || cond.value === null || cond.value === undefined) {
              throw new Error(
                `Item ${index + 1}, Condition ${cIndex + 1}: Value is required`
              );
            }

            if (!/^\d{6}$/.test(String(cond.value))) {
              throw new Error(
                `Item ${index + 1}, Condition ${cIndex + 1}: Card BIN must be 6 digits`
              );
            }
            break;
        }

      });
    });
    return true;
  };
  const checkDuplicateImportedItems = (data: any[]) => {
    data.forEach((item, index) => {
      const isDuplicate = nodes.some((node) => {
        if (node.type !== "actionNode") return false;
        const sameAction =
          node.data.action === item.action.action &&
          JSON.stringify(node.data.gateway) === JSON.stringify(item.action.gateway) &&
          (node.data.cred_type ?? "existing") ===
            (item.action.cred_type ?? "existing");
        if (!sameAction) return false;
        if (
          item.action.action === "process_with_gateway" &&
          item.action.cred_type === "custom"
        ) {
          if (
            JSON.stringify(node.data.credentials ?? {}) !==
            JSON.stringify(item.action.credentials ?? {})
          ) {
            return false;
          }
        }
        const connectedEdge = edges.find(
          (e) => e.target === node.id
        );
        if (!connectedEdge) return false;
        const conditionNode = nodes.find(
          (n) => n.id === connectedEdge.source
        );
        if (!conditionNode || conditionNode.type !== "conditionNode")
          return false;
        const sameConditions =
          JSON.stringify(conditionNode.data.conditions) ===
          JSON.stringify(item.condition);
        return sameConditions;
      });

      if (isDuplicate) {
        throw new Error(
          `Item ${index + 1}: Duplicate routing rule already exists`
        );
      }
    });
    return true;
  };
  const handleImport = async () => {
    setFormValuesErr("");
    let parsedJson: Record<string, any> | null = null;

    if (uploadFileType) {
      if (!jsonFile) {
        setFormValuesErr("JSON file is required");
        return;
      }
      parsedJson = jsonFile;
    } else {
      if (!jsonText.trim()) {
        setFormValuesErr("JSON content is required");
        return;
      }
      try {
        parsedJson = JSON.parse(jsonText);
      } catch {
        setFormValuesErr("Invalid JSON format");
        return;
      }
    }

    if (!Array.isArray(parsedJson)) {
      toast.error("Invalid smart routing JSON");
      return;
    }

    try {
      validateImportedJSON(parsedJson);
      checkDuplicateImportedItems(parsedJson);
      buildFlowFromJSON(parsedJson);
      setIsImportLoading(true);
      toast.success("JSON imported successfully");
      handleImportClose();
    } catch (error) {
      toast.error(
        error instanceof Error
          ? error.message
          : "Import failed. Please try again."
      );
    } finally {
      setIsImportLoading(false);
    }
  };
  const fetchNormalGateways = async () => {
    const gateways = await ClientGatewaysForSmartRouting(clientId);
    return gateways.map((gateway: any) => ({
      id: gateway.id,
      name: singleRoleData[0]?.client?.value?.client_show_method_name
        ? gateway.name
        : gateway.id,
    }));
  };
  const fetchSuccessGateways = async () => {
    const successGateways = await ClientSuccessGatewaysForSmartRouting(clientId);
    return successGateways.map((gateway: any) => ({
      id: gateway.id,
      name: singleRoleData[0]?.client?.value?.client_show_method_name
        ? gateway.name
        : gateway.id,
    }));
  };
  useEffect(() => {
    const loadData = async () => {
      try {
        const [gateways, successGateways] = await Promise.all([
          fetchNormalGateways(),
          fetchSuccessGateways()
        ]);

        const successIds = new Set(
          successGateways.map((gateway: any) => gateway.id)
        );

        const reorderedForSuccess = [...gateways].sort((a: any, b: any) => {
          const aIsSuccess = successIds.has(a.id);
          const bIsSuccess = successIds.has(b.id);

          if (aIsSuccess && !bIsSuccess) return -1;
          if (!aIsSuccess && bIsSuccess) return 1;
          return 0;
        });

        setStoreDropDownData(gateways);
        setStoreSuccessDropDownData(reorderedForSuccess);

        fetchRoutingData(gateways,reorderedForSuccess);
      } catch (err) {
        console.error(err);
      }
    };

    loadData();
  }, []);
  const fetchRoutingData = (gatewaysData : any[] , successGatewaysData : any[]) => {
    getSmartRouting(clientId)
    .then(async(data: any) => {
      if (data?.route_nodes?.length > 0) {
        if(data?.route_nodes && data?.route_edges && data?.route_info) {
          const hydratedNodes = data.route_nodes.map(enhanceNodeData);
          const updatedNodes = hydratedNodes.map((node: any) => {
            const conditionNodes = hydratedNodes.filter(
              (n: any) => n.type === "conditionNode"
            );
            if ( node.type === "actionNode") {
              if(node.data.action === "process_with_priority") {
                const existingGatewayIds: any[] = node?.data?.gateway || [];
                const existingOrderMap = new Map(
                  existingGatewayIds.map((id, index) => [id, index])
                );
                const gatewayIdSet = new Set(existingGatewayIds);
                gatewaysData.forEach((g: any) => {
                  if (g?.id && !gatewayIdSet.has(g.id)) {
                    gatewayIdSet.add(g.id);
                  }
                });
                const orderedGateways = gatewaysData?.length
                  ? [...gatewaysData].sort((a: any, b: any) => {
                      const aIndex = existingOrderMap.has(a.id)
                        ? existingOrderMap.get(a.id)
                        : Number.MAX_SAFE_INTEGER;

                      const bIndex = existingOrderMap.has(b.id)
                        ? existingOrderMap.get(b.id)
                        : Number.MAX_SAFE_INTEGER;

                      return aIndex - bIndex;
                    })
                  : [];
                return {
                  ...node,
                  data: {
                    ...node.data,
                    cred_type: node.data?.cred_type ?? "existing",
                    credentials: node.data?.credentials ?? {}, 
                    status : node.data?.status ?? "",
                    status_description : node.data?.status_description ?? "",
                    gateway: Array.from(gatewayIdSet),
                    gateways : orderedGateways,
                    successGateways:  successGatewaysData?.length ? successGatewaysData : [],
                    fetchSuccessGateways,
                    fetchNormalGateways
                  },
                };
              } else if(node.data.action === "process_with_last_success") {
                return {
                  ...node,
                  data: {
                    ...node.data,
                    cred_type: node.data?.cred_type ?? "existing",
                    credentials: node.data?.credentials ?? {}, 
                    status : node.data?.status ?? "",
                    status_description : node.data?.status_description ?? "",
                    gateways : gatewaysData,
                    successGateways: successGatewaysData?.length ? successGatewaysData : [],
                    fetchSuccessGateways,
                    fetchNormalGateways
                  },
                };
              } else {
                return {
                  ...node,
                  data: {
                    ...node.data,
                    cred_type: node.data?.cred_type ?? "existing",
                    credentials: node.data?.credentials ?? {}, 
                    status : node.data?.status ?? "",
                    status_description : node.data?.status_description ?? "",
                    gateways : gatewaysData,
                    successGateways: successGatewaysData?.length ? successGatewaysData : [],
                    fetchSuccessGateways,
                    fetchNormalGateways
                  },
                };
              }
            }
            if (node.type === "conditionNode") {
              const index =
                conditionNodes.findIndex((n: any) => n.id === node.id) + 1;

              return {
                ...node,
                data: {
                  ...node.data,
                  titleIndex: index,
                },
              };
            }
            return node;
          });
          setNodes(updatedNodes)
          setEdges(data?.route_edges)
          setJSON(data?.route_info)
          return;
        }
      }
      if (gatewaysData?.length > 0) {
        const conditionNodeId = crypto.randomUUID();
        const actionNodeId = crypto.randomUUID();
        const defaultConditionNode: Node = {
          id: conditionNodeId,
          type: "conditionNode",
          position: {
            x: 150,
            y: 100,
          },
          data: {
            id: conditionNodeId,
            titleIndex: 1,
            conditions: [
              {
                key: "day",
                operator: "in",
                value: allDays.map((day: any) => day.value),
              },
            ],
            onChange: updateNodeData,
            onRemove: removeNode,
            addCondition,
            removeCondition,
          },
        };
        const defaultActionNode: Node = {
          id: actionNodeId,
          type: "actionNode",
          position: {
            x: 600,
            y: 100,
          },
          data: {
            id: actionNodeId,
            action: "process_with_gateway",
            gateway: gatewaysData[0].id,
            cred_type: "existing",
            credentials: {},
            status: "",
            status_description: "",
            gateways: gatewaysData,
            successGateways: successGatewaysData ?? [],
            fetchSuccessGateways,
            fetchNormalGateways,
            onChange: updateNodeData,
            onRemove: removeNode,
          },
        };
        const defaultEdge: Edge = {
          id: `e-${conditionNodeId}-${actionNodeId}`,
          source: conditionNodeId,
          target: actionNodeId,
          animated: true,
          style: {
            stroke: "#2196f3",
          },
        };
        setNodes([defaultConditionNode,defaultActionNode]);
        setEdges([defaultEdge]);
        const generated = await generateJSON(true);
        if(generated && JSON.parse(generated).length > 0) {
          const data = {
            route_info: JSON.parse(generated),
            route_nodes : nodes,
            route_edges : edges
          }
          const updateData = createSmartRoutingNew(data,clientId);
        }
        return;
      }
      setNodes([]);
      setEdges([]);
      setJSON("");
    })
    .catch((err: any) => {})
    .finally(() => {
      setLoading(false);
    });
  } 
  return (
    <>
      <Card extra={"w-full h-full sm:overflow-auto px-6"}>
        <div className="relative mt-4 overflow-x-auto overflow-x-auto scrollbar scrollbar-track-gray-100 scrollbar-thumb-gray-300 scrollbar-track-rounded-full scrollbar-thumb-rounded-xl scrollbar-h-1.5 sm:rounded-lg ">
          <div className="flex  justify-between gap-3">
            <div className="flex gap-2">
              <button onClick={addConditionNode} className="flex items-center rounded-xl border border-blue-300 bg-blue-50 px-5 py-2 text-blue-500 outline-none">
                <FiPlusSquare size={20} /> <span className="ml-2">Add Condition</span>
              </button>
              <button onClick={addActionNode} className="flex items-center ml-2 rounded-xl border border-blue-300 bg-blue-50 px-5 py-2 text-blue-500 outline-none">
                <FiPlusSquare size={20} /> <span className="ml-2">Add Action</span>
              </button>
            </div>
            <div className="flex gap-2">
              <Link className="inline-flex" to={`/admin/client-details/${clientId}`} >
                <button className="flex items-center gap-2 w-fit rounded-lg border px-4 py-2 outline-none border-red-300 bg-indigo-50 text-red-500">
                  <BsArrowLeft size={14} /> 
                  Back To Client Profile
                </button>
              </Link>
              {singleRoleData[0]?.client?.value?.import_smart_route_json && (
                <button onClick={() => importJSON(false)} className="flex items-center ml-2 rounded-xl border border-yellow-300 bg-blue-50 px-5 py-2 text-yellow-500 outline-none">
                  <BsFiletypeJson size={20} /> <span className="ml-2">Import JSON</span>
                </button>
              )}
              <button onClick={() => generateJSON(false)} className="flex items-center ml-2 rounded-xl border border-blue-300 bg-blue-50 px-5 py-2 text-blue-500 outline-none">
                <BsFiletypeJson size={20} /> <span className="ml-2">Generate JSON</span>
              </button>
              <button onClick={saveChanges} className="flex items-center ml-2 rounded-xl border border-teal-300 bg-teal-50 px-5 py-2 text-teal-500 outline-none">
                {isSubmitLoading ? (
                  <DivLoader className="h-6 w-6 border-teal-300" />
                ):(
                  <>
                    <FiSave size={20} /> <span className="ml-2">Save Changes</span>
                  </>
                )}
              </button>
              </div>
          </div>
          <div className="h-[90vh] my-4 w-full border-2 border-gray-300 rounded-lg">
            <ReactFlow
              nodes={nodes}
              edges={edges}
              onNodesChange={onNodesChange}
              onEdgesChange={onEdgesChange}
              onConnect={onConnect}
              nodeTypes={nodeTypes}
              fitView
            >
              <MiniMap />
              <Controls />
              <Background />
            </ReactFlow>
          </div>
          <Modal isOpen={isOpen} onClose={() => {}}>
            <ModalOverlay className="bg-[#000] !opacity-30" />
              <Card extra={`fixed top-0 right-0 h-full rounded-none max-w-[600px] sm:w-full flex flex-col justify-start !z-[1004] overflow-y-auto scrollbar-hide overflow-auto ${
              isOpen && !isCloseModal ? "card-enter" : "card-exit"
              }`}>
                <ModalHeader className=" flex py-[20px] mb-[20px] px-[30px] text-2xl font-bold bg-brand-500 text-white">
                        <MdHighlightOff
                        className="absolute right-7 top-6 h-8 w-8 cursor-pointer text-white"
                        onClick={handleClose}
                        />
                        JSON View
                </ModalHeader>     
                <ModalBody className="p-4">
                  <div className="flex relative flex-col  overflow-auto mx-[35px] rounded-xl border border-gray-100  scrollbar scrollbar-h-1.5 scrollbar-track-gray-100 scrollbar-thumb-gray-300 scrollbar-track-rounded-full scrollbar-thumb-rounded-xl scrollbar-w-1.5">
                    <pre className="p-2">{createdJson}</pre>
                    <div className="absolute top-3 right-3 outline-none">
                      {copyJson ?
                        <MdCheck className="cursor-pointer text-teal-500 mr-4" />
                        :
                        <MdFileCopy
                          className="cursor-pointer text-teal-500 mr-4"
                          onClick={() => {
                                  navigator.clipboard.writeText(createdJson)
                                  setCopyJson(true);
                                  setTimeout(() => { setCopyJson(false) }, 1500)
                          }}
                        />
                      }
                    </div>
                  </div>
                </ModalBody>   
                <ModalFooter className="mt-[10px] p-4">
                  <div className="mt-5 flex gap-2">
                    <button
                      onClick={handleClose}
                      className="linear rounded-xl bg-gray-100 px-5 py-2 text-base font-medium text-navy-700 outline-none transition duration-200 hover:bg-gray-200 active:bg-gray-300 dark:bg-white/10 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/30"
                    >
                      Close
                    </button>
                  </div>
                </ModalFooter>
              </Card>
          </Modal>
          <Modal isOpen={isOpenImport} onClose={handleImportClose}>
            <ModalOverlay className="bg-[#000] !opacity-30" />
            <Card extra={`fixed top-0 right-0 h-full rounded-none max-w-[600px] sm:w-full flex flex-col justify-start !z-[1004] overflow-y-auto scrollbar-hide overflow-auto ${
              isOpenImport && !isCloseImportModal ? "card-enter" : "card-exit"
              }`}>
                <ModalHeader className=" flex py-[20px] mb-[20px] px-[30px] text-2xl font-bold bg-brand-500 text-white">
                  <MdHighlightOff
                    className="absolute right-7 top-6 h-8 w-8 cursor-pointer text-white"
                    onClick={handleImportClose}
                    />
                    Import JSON
                </ModalHeader>     
                <ModalBody className="p-4">
                  <div className="px-[20px]">
                    <div className="rounded-lg border border-gray-200 bg-gray-50 p-4">
                      <div className="mb-4">
                        <p className="mb-2 text-sm font-semibold text-gray-800">
                          Sample Files
                        </p>
                        <div className="flex flex-wrap gap-4">
                          <a
                            href={URL.createObjectURL(
                              new Blob([JSON.stringify(SampleJson, null, 2)], {
                                type: "application/json",
                              })
                            )}
                            download="smart-routing-sample.json"
                            className="inline-flex items-center gap-2 rounded-md border border-blue-200 bg-blue-50 px-3 py-2 text-sm font-medium text-blue-700 hover:bg-blue-100"
                          >
                            📄 Download Sample JSON
                          </a>
                          <a
                            href={SampleJsonRule}
                            download="smart-routing-rules.txt"
                            className="inline-flex items-center gap-2 rounded-md border border-indigo-200 bg-indigo-50 px-3 py-2 text-sm font-medium text-indigo-700 hover:bg-indigo-100"
                          >
                            📘 Download Rules Guide
                          </a>
                        </div>
                      </div>
                      <div className="flex items-center justify-between">
                        <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
                          {uploadFileType
                            ? "Switch to manual JSON input"
                            : "Switch to JSON file upload"}
                        </span>
                        <label className="relative inline-flex cursor-pointer items-center">
                          <input
                            type="checkbox"
                            className="peer sr-only"
                            checked={uploadFileType}
                            onChange={() => {
                              setUploadFileType(!uploadFileType);
                              setFormValuesErr("");
                              setJsonFile(null);
                              setJsonText("");
                            }}
                          />
                          <div
                            className="h-6 w-11 rounded-full bg-gray-400
                              peer-checked:bg-indigo-600
                              peer-focus:outline-none peer-focus:ring-4
                              peer-focus:ring-indigo-400
                              after:absolute after:left-[2px] after:top-[2px]
                              after:h-5 after:w-5 after:rounded-full after:bg-white
                              after:transition-transform
                              peer-checked:after:translate-x-full"
                          />
                        </label>
                      </div>
                    </div>
                    {uploadFileType ? ( 
                      <div className="flex gap-5 mt-3 mb-4">
                        <div className="w-full ">
                            <div className="flex flex-col ">
                                <p className="mb-3 ml-1.5 text-sm font-bold text-gray-900">
                                    JSON File * 
                                </p>
                                <FileDropzone label="Upload JSON File" onFileSelect={setJsonFile} onRemoveFile={setRemoveFile} resetKey={resetKey}/>
                            </div>
                            {formValuesErr && (
                                <p className="text-sm mt-1 text-orange-500">
                                {formValuesErr}
                                </p>
                            )}
                        </div>
                    </div>
                    ) : (
                      <div className="flex gap-5 mt-3 mb-4">
                        <div className="w-full">
                          <div className="flex flex-col">
                            <p className="mb-3 ml-1.5 text-sm font-bold text-gray-900">
                              JSON Content *
                            </p>

                            <textarea
                              rows={6}
                              placeholder="Paste JSON here..."
                              value={jsonText}
                              onChange={(e) => setJsonText(e.target.value)}
                              className="w-full rounded-lg border border-gray-300 p-3 text-sm font-mono
                                        focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200
                                        dark:bg-gray-800 dark:text-white"
                            />
                          </div>

                          {formValuesErr && (
                            <p className="text-sm mt-1 text-orange-500">
                              {formValuesErr}
                            </p>
                          )}
                        </div>
                      </div>
                    )}
                    <div className="mt-3 rounded-lg border border-red-200 bg-red-50 px-4 py-2">
                      <p className="text-sm text-red-600 font-medium">
                        ⚠️ Note: Don’t forget to save the changes after importing the JSON.
                      </p>
                    </div>
                    
                  </div>
                </ModalBody>
                <ModalFooter className="mt-[10px] p-4">
                  <div className="mt-5 flex gap-2">
                    <button
                      onClick={handleImportClose}
                      className="linear rounded-xl bg-gray-100 px-5 py-2 text-base font-medium text-navy-700 outline-none transition duration-200 hover:bg-gray-200 active:bg-gray-300 dark:bg-white/10 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/30"
                    >
                      Close
                    </button>
                    <button onClick={handleImport} disabled={isImportLoading} className="linear rounded-xl bg-indigo-600 px-5 py-2 text-base font-medium text-white outline-none transition duration-200 hover:bg-indigo-600 active:bg-indigo-600 dark:bg-indigo-400/10 dark:text-white dark:hover:bg-indigo-300/10 dark:active:bg-indigo-200/10">
                        {isImportLoading ? (
                            <DivLoader className="h-6 w-6 border-white" />
                        ) : (
                            "Import"
                        )}
                    </button>
                  </div>
                </ModalFooter>
              </Card>
          </Modal>
        </div>
      </Card>
    </>
  );
}
